{
  "fr": {
    "labels": {
      "locationInput": {
        "linked": "Lié à"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "Tout",
        "search": "Chercher dans cette boutique",
        "categories": "Catégories",
        "sortName": "Nom",
        "sortPrice": "Prix",
        "emptyName": "article",
        "kind": "Boutique",
        "items": "Articles",
        "facts": "Points clés",
        "place": "Lieu",
        "system": "Système",
        "carries": "Vend",
        "source": "Prix et stock issus d’UEX."
      },
      "location": {
        "missionsSample": "Les comptes portent sur les %{shown} premières sur %{total}.",
        "people": "Amis et flotte ici",
        "peopleFriend": "Ami",
        "peopleUnlisted": "%{count} de plus non listés",
        "systemUnavailable": "Impossible de charger ce système.",
        "systemsUnavailable": "Impossible de charger les systèmes.",
        "resourceKinds": {
          "ship_mineables": "Minerais au vaisseau",
          "hand_mineables": "Minerais à la main",
          "ground_vehicle_mineables": "Minerais au véhicule terrestre",
          "harvestables": "Récoltables",
          "creatures": "Créatures"
        },
        "resources": "Ressources",
        "moonsBadge": "Lunes",
        "planets": "Planètes",
        "places": "Lieux",
        "showFewer": "Afficher moins",
        "showAll": "Afficher les %{count}",
        "elsewhere": "Ailleurs autour de %{star}",
        "namesakes": "×%{count}",
        "lagrangePoints": "Points de Lagrange",
        "inOrbit": "En orbite",
        "moons": {
          "one": "%{count} lune",
          "other": "%{count} lunes"
        },
        "gateways": "Portails de saut",
        "jumpPoints": "Points de saut",
        "notInGameYet": "Pas encore dans le jeu",
        "jumpLegend": {
          "title": "Connexions de saut",
          "inGame": "Dans le jeu",
          "temporary": "Temporaire",
          "planned": "Prévu"
        },
        "systemStrip": "%{system}, de son étoile vers l'extérieur",
        "allSystems": "Tous les systèmes",
        "allPlaces": "Tous les lieux",
        "shops": "Boutiques",
        "shopItems": {
          "one": "%{count} article",
          "other": "%{count} articles"
        },
        "shopItemTypes": {
          "Model": "Vaisseau",
          "ModelModule": "Module",
          "ModelPaint": "Peinture",
          "Component": "Composant",
          "Equipment": "Équipement",
          "Commodity": "Marchandise"
        },
        "bodyTypes": {
          "gas_giant": "Géante gazeuse",
          "ice_giant": "Géante de glace",
          "asteroid": "Astéroïde",
          "city": "Planète-ville"
        },
        "unstable": "Instable",
        "unstableHint": "Une étoile à éruptions : son rayonnement s’emballe sans prévenir.",
        "systems": "Systèmes stellaires",
        "name": "Nom",
        "kind": "Type",
        "retired": "Absent de cette version",
        "starmap": "Carte stellaire",
        "starmapVisibility": "Carte en jeu",
        "starmapHidden": "Masqué sur la carte",
        "starmapAlways": "Toujours affiché sur la carte",
        "starmapWithParent": "Affiché une fois %{parent} sélectionné",
        "starmapShown": "Affiché sur la carte",
        "quantumTravel": "Voyage quantique",
        "quantumTravelYes": "Oui",
        "quantumTravelNo": "Non",
        "mapParent": "Dessiné sous",
        "mapParentNote": "La carte en jeu le dessine sous %{mapParent}, bien qu'il se trouve dans %{parent}.",
        "missions": "Missions",
        "allMissions": "Toutes les missions pouvant se dérouler ici",
        "terminals": "Terminaux commerciaux",
        "alwaysShown": "Toujours sur la carte",
        "hiddenOnStarmap": "Masqué sur la carte",
        "kinds": {
          "system": "Système stellaire",
          "star": "Étoile",
          "planet": "Planète",
          "moon": "Lune",
          "city": "Ville",
          "station": "Station",
          "outpost": "Avant-poste",
          "clinic": "Clinique",
          "district": "Quartier",
          "asteroid": "Astéroïde",
          "anomaly": "Anomalie",
          "jump_point": "Point de saut",
          "point_of_interest": "Point d'intérêt",
          "nav_point": "Point de navigation",
          "other": "Autre"
        }
      },
      "sortOptions": "Options de tri",
      "loading": "Chargement…",
      "loadingNamed": "Chargement de %{name}…",
      "true": "Oui",
      "false": "Non",
      "null": "nul",
      "presets": {
        "title": "Choisir une image",
        "filter": "Type",
        "all": "Toutes",
        "empty": "Aucune image disponible."
      },
      "supporter": {
        "badge": "Soutien",
        "tooltip": "Soutient FleetYards.net ce mois-ci",
        "none": "Pas un soutien",
        "fleetTierUntil": "Niveau de flotte jusqu'au %{date}",
        "fleetTierExpired": "Expiré",
        "fleetTierOngoing": "Niveau de flotte tant que l'abonnement dure",
        "until": "Actif jusqu'au %{date}",
        "expiring": "Expire le %{date}",
        "ongoing": "Récurrent, sans date de fin",
        "tierShort": "Niveau %{tier}",
        "tierShortRecurring": "Niveau %{tier}, récurrent",
        "recurringShort": "Récurrent"
      },
      "destroyedFleets": {
        "discarded": "Écartée",
        "purged": "Purgée"
      },
      "and": "et",
      "hide": "Masquer",
      "show": "Afficher",
      "only": "Uniquement",
      "description": "Description",
      "unavailable": "indisponible",
      "selected": "Sélectionné",
      "actions": "Actions",
      "status": "Statut",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "collapse": "Réduire",
      "price": "Prix",
      "expand": "Agrandir",
      "distance": "Distance",
      "anonymous": "Anonyme",
      "refreshing": "Actualisation...",
      "toggleNavigation": "Changer de navigation",
      "openInNewWindow": "Ouvrir en plein écran",
      "or": "ou",
      "groups": "Groupes",
      "classifications": "Classifications",
      "features": {
        "stateOn": "Activé",
        "stateOff": "Désactivé",
        "stateConditional": "Conditionnel",
        "openFor": "Ouvert depuis %{days} jours",
        "historyEmpty": "Rien n'a encore été enregistré pour cette fonctionnalité.",
        "historyBy": "par %{actor}",
        "sources": {
          "admin": "Administration",
          "self_service": "Libre-service",
          "sync": "Déploiement",
          "console": "Console",
          "backfill": "Rétro-rempli"
        },
        "selfService": "Libre-service",
        "actors": "Acteurs",
        "groups": "Groupes",
        "noGroups": "Aucun groupe activé pour cette fonctionnalité.",
        "noActors": "Aucun acteur individuel activé pour cette fonctionnalité.",
        "user": "Utilisateur",
        "fleet": "Flotte",
        "actorType": "Type d'acteur",
        "percentageOfActors": "des acteurs",
        "percentageOfTime": "du temps",
        "currentState": "État actuel",
        "toggle": "Basculer",
        "permanent": "Permanent",
        "tabs": {
          "all": "Toutes",
          "rollout": "Déploiement",
          "permanent": "Permanentes"
        },
        "settingsIntro": "Activez ou désactivez les fonctionnalités expérimentales pour votre compte. Ces fonctionnalités peuvent être incomplètes ou changer sans préavis.",
        "registryHint": "Les flags sont déclarés dans config/feature_flags.yml et créés au déploiement. Vous contrôlez ici leurs conditions d'activation.",
        "fleetSettingsIntro": "Activez ou désactivez des fonctionnalités pour toute la flotte. Tous les membres voient ce que vous activez ici.",
        "fleetFeature": "Fonctionnalité de flotte",
        "fleetFeatureInfo": "L'activer ici ne l'active que pour vous. Les administrateurs de votre flotte peuvent l'activer pour toute la flotte.",
        "toggleForSelf": "Activer pour vous uniquement",
        "fleetFeatureGrantedShort": "Activé par la flotte",
        "fleetFeatureGranted": "Votre flotte l'a activé pour tous les membres, il ne peut donc pas être désactivé ici.",
        "groupFeatureGrantedShort": "Activé par le groupe",
        "groupFeatureGranted": "Un groupe dont vous faites partie a activé cette fonctionnalité, elle ne peut donc pas être désactivée ici.",
        "groupFeatureGrantedFleet": "Un groupe dont cette flotte fait partie a activé cette fonctionnalité, elle ne peut donc pas être désactivée ici.",
        "managedFeatureShort": "Géré",
        "managedFeature": "Cette fonctionnalité a été activée pour votre compte et ne peut pas être modifiée ici.",
        "managedFeatureFleet": "Cette fonctionnalité a été activée pour cette flotte et ne peut pas être modifiée ici.",
        "selfServiceUser": "Les utilisateurs peuvent basculer",
        "selfServiceFleet": "Les admins de flotte peuvent basculer"
      },
      "oauthApplication": {
        "name": "Nom de l'application",
        "clientId": "ID client",
        "clientSecret": "Secret client",
        "redirectUri": "URI de redirection",
        "redirectUriHint": "Utilisez une URI par ligne.",
        "confidential": "Confidentiel",
        "scopes": "Portées",
        "scopesHint": "Si aucune portée n'est sélectionnée, les portées par défaut seront utilisées : %{scopes}",
        "logo": "Logo",
        "logoHint": "Affiché sur l'écran de consentement afin que les utilisateurs reconnaissent votre application. PNG, JPG, GIF ou WebP."
      },
      "rsiRequestLogs": {
        "resolved": "Résolu",
        "unresolved": "Non résolu"
      },
      "imports": {
        "type": "Type",
        "status": "Statut",
        "version": "Version",
        "startedAt": "Démarré",
        "finishedAt": "Terminé",
        "failedAt": "Échec à",
        "info": "Info",
        "input": "Entrée",
        "output": "Sortie",
        "importData": "Données d'import",
        "file": "Fichier importé",
        "requestedBy": "Demandé par",
        "adminUser": "Administrateur",
        "user": "Utilisateur",
        "includeSystem": "Inclure le système",
        "systemRequester": "système",
        "statuses": {
          "created": "En file d'attente",
          "started": "En cours",
          "finished": "Terminé",
          "failed": "Échoué",
          "cancelled": "Annulé"
        },
        "intro": "Tous les imports de hangar et synchronisations RSI que vous avez lancés, les plus récents en premier.",
        "targetGroupHint": "Choisissez un groupe de hangar et chaque vaisseau importé y sera classé. Laissez vide pour utiliser les groupes indiqués dans le fichier.",
        "types": {
          "Imports::HangarImport": "Import de hangar",
          "Imports::HangarSync": "Synchronisation du hangar RSI"
        },
        "summary": {
          "imported": "Importés",
          "missing": "Introuvables",
          "found": "Associés"
        },
        "formatHint": "Deux formats de fichier sont acceptés :",
        "formats": {
          "fleetyards": "Un export de hangar FleetYards — utilisez le bouton Exporter pour le créer.",
          "hangarXplor": "Un export hangarXPLOR."
        },
        "details": {
          "imported": "Ajoutés",
          "found": "Associés",
          "movedToWanted": "Déplacés vers la liste de souhaits",
          "deleted": "Supprimés",
          "grouped": "Classés dans un groupe",
          "unchanged": "Laissés inchangés",
          "missing": "Vaisseaux introuvables",
          "missingComponents": "Composants introuvables",
          "missingUpgrades": "Améliorations introuvables"
        },
        "noDetails": "Cette exécution n'a enregistré aucun détail."
      },
      "oauthApplications": {
        "settingsIntro": "Gérez vos applications OAuth. Ces applications peuvent accéder à l'API FleetYards au nom des utilisateurs.",
        "name": "Nom de l'application",
        "redirectUri": "URI de redirection",
        "confidential": "Confidentiel",
        "clientId": "ID client",
        "clientSecret": "Secret client",
        "scopes": "Portées",
        "defaultScopes": "Portées par défaut",
        "confidentialShort": "Confidentiel",
        "publicShort": "Public",
        "logo": "Logo",
        "state": "Statut",
        "rejectionReason": "Motif du refus",
        "statePending": "En attente d'examen",
        "stateApproved": "Approuvée",
        "stateRejected": "Refusée",
        "reviewedBy": "Examinée par",
        "owner": "Enregistrée par"
      },
      "fleetInviteToken": "invitation de la flotte",
      "inviteToken": "Code d'invitation",
      "scDataVersion": "Version corrigée",
      "title": "Titre",
      "createdAt": "Créé le",
      "updatedAt": "Mis à jour le",
      "addToHangar": "Ajouter au hangar",
      "home": {
        "search": "Recherche de vaisseaux"
      },
      "shop": {
        "sellPrice": "prix de vente",
        "buyPrice": "prix d'achat"
      },
      "shopCommodity": {
        "item": "Objets",
        "shop": "Magasin",
        "buyPrices": "Prix d'achat",
        "rentalPrices": "Prix de location",
        "confirmed": "Confirmé ",
        "prices": {
          "label": "prix",
          "sellPrice": "prix de vente",
          "buyPrice": "Achats pour"
        }
      },
      "statsCard": {
        "more": "+%{count} de plus sur la page de détails",
        "unavailable": "Impossible de charger ces détails.",
        "loading": "Chargement de %{name}…",
        "offeredBy": "Proposée par %{name}",
        "rsiHandle": "Handle RSI : %{handle}",
        "types": {
          "Component": "Composant",
          "Equipment": "Équipement",
          "Commodity": "Marchandise",
          "Model": "Vaisseau",
          "Blueprint": "Plan",
          "GameMission": "Mission",
          "Location": "Lieu",
          "FleetContract": "Contrat",
          "FleetEvent": "Événement",
          "User": "Utilisateur"
        },
        "open": {
          "Component": "Ouvrir le composant",
          "Equipment": "Ouvrir l’équipement",
          "Commodity": "Ouvrir la marchandise",
          "Model": "Ouvrir le vaisseau",
          "Blueprint": "Ouvrir le plan",
          "GameMission": "Ouvrir la mission",
          "Location": "Ouvrir le lieu",
          "FleetContract": "Ouvrir le contrat",
          "FleetEvent": "Ouvrir l’événement",
          "User": "Ouvrir le hangar"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nouveaux vaisseaux en %{year}",
          "totalShips": "Nombre total de vaisseaux",
          "totalMembers": "Nombre total de membres",
          "vehicles": "Vaisseaux en hangar",
          "wishlists": "Vaisseaux en liste de souhaits",
          "shipOfTheMonth": "Vaisseau du mois"
        },
        "modelsByClassification": "Vaisseaux par catégorie",
        "modelsBySize": "Vaisseaux par taille",
        "vehiclesByModel": "Vaisseau par modèle (Top %{limit})",
        "modelsPerMonth": "Vaisseaux par mois",
        "modelsByManufacturer": "Vaisseaux par constructeur",
        "modelsByProductionStatus": "Vaisseau par état de production",
        "vehiclesPerMonth": "Vaisseaux en hangar par mois",
        "topVehiclesByModel": "Top 10 vaisseaux en hangar",
        "shipsOfTheMonth": "Vaisseau du mois",
        "trendingShips": "Vaisseaux les plus consultés (30 jours)",
        "wishlistByModel": "Vaisseaux les plus souhaités",
        "wishToOwnRatio": "Souhaités pour 100 possédés",
        "topPaints": "Peintures les plus populaires",
        "paintedVehicles": "Vaisseaux peints",
        "pledgePriceChanges": "Variations de prix pledge (12 mois)",
        "ingamePriceChanges": "Variations de prix en jeu (30 jours)",
        "mostWishlisted": "Vaisseaux les plus souhaités ce mois-ci",
        "patchChanges": "Les plus modifiés par ce patch",
        "crewDeficit": "Déficit d'équipage",
        "crewSurplus": "Excédent d'équipage",
        "membersByRole": "Membres par rôle",
        "csv": {
          "metric": "Métrique",
          "value": "Valeur",
          "count": "Nombre"
        }
      },
      "roadmap": {
        "releases": "toutes les publications",
        "released": "publiée",
        "lastVersion": {
          "active": {
            "false": "Élément retiré de la feuille de route",
            "true": "Élément réajouté à la feuille de route"
          },
          "released": "L'élément a été publié dans le PU",
          "release": "Élément déplacé de la version %{old} à %{new}"
        },
        "stories": {
          "one": "%{count} stocké",
          "other": "%{count} stockés"
        },
        "tasks": {
          "one": "de %{count} tâche",
          "other": "de %{count} tâches"
        },
        "ships": {
          "one": "%{count} vaisseau",
          "other": "%{count} Vaisseaux"
        }
      },
      "unknown": "inconnu",
      "none": "nul",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Nom",
      "homepage": "Page principale",
      "discord": "Serveur Discord",
      "youtube": "Chaîne Youtube",
      "twitch": "Chaîne Twitch",
      "guilded": "Serveur Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "viewInAr": "RA",
      "viewInArHint": "Placez-le dans votre pièce en taille réelle",
      "filter": "Filtre",
      "taxExcluded": "hors TVA",
      "hangar": "Hangar",
      "public": "Publique",
      "hangarStats": "Statistiques",
      "wishlist": "Liste de souhait",
      "fleetchart": "Graphique de la Flotte",
      "fleetchartApp": {
        "screenHeight": "Hauteur de l'écran",
        "viewpoint": "Point de vue",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Côté",
          "top": "Haut",
          "angled": "En biais",
          "front": "Face"
        },
        "gridSize": "%{size} mètre par zone de grille",
        "mode": "Mode",
        "modeOptions": {
          "classic": "Classique",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiques",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Valeur de la monnaie",
        "totalCredits": "Crédits",
        "totalIngameValue": "Valeur aUEC du hangar",
        "totalMinCrew": "Équipage minimum",
        "totalMaxCrew": "Équipage maximum",
        "totalCargo": "Cargaison totale",
        "largestShip": "Plus grand vaisseau",
        "smallestShip": "Plus petit vaisseau",
        "averagePledgePrice": "Prix de Pledge moy.",
        "flightReady": "Prêt au vol",
        "uniqueModels": "Modèles uniques",
        "manufacturerCount": "Fabricants",
        "missingClassifications": "Rôles manquants",
        "wishlistTotalMoney": "Valeur de Pledge de la liste de souhaits",
        "wishlistTotalCredits": "Valeur en jeu de la liste de souhaits"
      },
      "selectModel": "Sélectionner un vaisseau",
      "findModel": "Trouver un vaisseau",
      "find": "Saisissez votre recherche",
      "selectUser": "Sélectionner un utilisateur",
      "findUser": "Tapez pour trouver un utilisateur",
      "selectAdminUser": "Sélectionner un administrateur",
      "selectFleet": "Sélectionner une flotte",
      "findFleet": "Tapez pour trouver une flotte",
      "compare": {
        "removeModel": "Enlever un vaisseau",
        "addModel": {
          "nullablePrompt": "Ajouter un vaisseau"
        },
        "enough": "Ne pensez-vous pas que 8 vaisseaux suffisent ? ;)",
        "shipCount": {
          "one": "%{count} vaisseau",
          "other": "%{count} vaisseaux"
        },
        "containersOfSize": "Conteneurs de %{size} SCU",
        "armorHp": "HP du blindage",
        "fuelAndQuantum": "Carburant et Quantum",
        "weaponPoolSize": "Réserve d'énergie des armes",
        "crossSection": {
          "x": "Section transversale X",
          "y": "Section transversale Y",
          "z": "Section transversale Z"
        },
        "useAsBaseline": "Utiliser comme référence",
        "baseline": "Référence",
        "differencesOnly": "Différences uniquement",
        "compareToBaseline": "Comparer à la référence",
        "loadoutBySlot": "Équipement par emplacement",
        "slots": {
          "guns": "Canons principaux",
          "turrets": "Tourelles",
          "missiles": "Missiles",
          "shields": "Générateurs de boucliers",
          "powerPlants": "Réacteurs",
          "coolers": "Refroidisseurs",
          "quantumDrives": "Moteurs quantiques",
          "thrusters": "Propulseurs principaux",
          "countermeasures": "Contre-mesures"
        },
        "legend": {
          "best": "meilleur de la ligne",
          "worst": "pire",
          "share": "part du meilleur de la ligne",
          "better": "dépasse la référence",
          "worse": "en dessous"
        },
        "selectShips": "Sélectionner des vaisseaux"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vente",
      "buy": "Achat",
      "yourFlagship": "Votre vaisseau amiral",
      "flagship": "Vaisseau amiral",
      "fleet": {
        "headquarters": "Quartier général",
        "index": "Flotte",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotte",
        "fid": "Identifiant de la Flotte",
        "name": "Nom",
        "logo": "Logo",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "L’ID de flotte est l’adresse de ta flotte sur Fleetyards. Le SID relie la flotte à son organisation RSI, et le vérifier prouve que l’organisation t’appartient."
        },
        "fidClaim": {
          "claimableTitle": "Réclamer l’ID de flotte %{fid}",
          "claimable": "Ta flotte est vérifiée pour l’organisation RSI %{fid}, mais une autre flotte détient l’ID de flotte %{fid}. Si tu le réclames, cette flotte a 14 jours pour prouver elle-même l’organisation ou prévenir ses membres. Ensuite elle est renommée et %{fid} devient l’ID de ta flotte.",
          "pendingTitle": "Réclamation de %{fid} en cours",
          "pending": "%{holder} garde %{fid} jusqu’au %{date}. Ensuite l’ID passe à ta flotte, sauf si cette flotte prouve d’ici là qu’elle gère l’organisation %{fid}.",
          "availableTitle": "L’ID de flotte %{fid} est libre",
          "available": "Ta flotte est vérifiée pour %{fid} et aucune autre flotte n’utilise cet ID. Indique-le plus haut comme ID de ta flotte.",
          "incomingTitle": "%{claimant} réclame l’ID de ta flotte",
          "incoming": "%{claimant} est vérifiée pour l’organisation RSI **%{fid}**.\n\n**Le %{date} :**\n\n- Ta flotte passe au prochain ID de flotte libre, comme **%{fid}-1**.\n- Les liens vers %{fid} ouvriront ensuite %{claimant}.\n\n**Pour garder l’ID**, vérifie %{fid} avant cette date. Sinon, préviens tes membres du changement d’adresse.",
          "createTakenTitle": "%{fid} est déjà pris",
          "createTaken": "Si %{fid} est ton organisation RSI, commence avec %{suggestion} et le SID %{fid}. Dès que ta flotte est vérifiée pour %{fid}, elle peut réclamer l’ID de flotte à la flotte qui le détient."
        },
        "rsiVerification": {
          "steps": {
            "copy": "Copie ton code de vérification",
            "paste": "Colle-le n’importe où sur la page RSI publique de ton organisation : l’introduction, l’histoire, le manifeste ou la charte. Tu pourras le retirer une fois la flotte vérifiée.",
            "check": "Vérifie la page"
          },
          "openOrgPage": "Ouvrir %{sid} sur RSI",
          "locked": "Un SID vérifié est verrouillé. Contacte le support s’il doit changer.",
          "fidAtRiskTitle": "L’ID de ta flotte n’est pas protégé",
          "saveFirst": "Enregistre le SID avant de le vérifier.",
          "title": "Vérification RSI",
          "token": "Code de vérification",
          "verified": "Organisation RSI vérifiée",
          "unverified": "Non vérifiée auprès de RSI",
          "verifiedSince": "Vérifiée depuis le %{date}",
          "nextCheck": "Tu pourras vérifier à nouveau dans une minute.",
          "fidAtRisk": "Une autre flotte qui vérifie l’organisation RSI %{fid} peut le réclamer, et l’adresse de ta flotte change.",
          "statuses": {
            "pending": "Vérification de la page de l’organisation…",
            "token_missing": "Le code n’est pas encore sur la page de l’organisation. RSI peut mettre quelques minutes à afficher une modification.",
            "symbol_mismatch": "La page renvoyée par RSI appartient à une autre organisation.",
            "not_found": "RSI ne connaît aucune organisation avec ce SID.",
            "failed": "La page de l’organisation n’a pas pu être vérifiée. Réessaie dans une minute."
          }
        },
        "description": "Description",
        "public": "Aperçu publique de la Flotte",
        "publicFleet": "Flotte publique",
        "publicStats": "Statistiques publiques",
        "publicFleetStats": "Statistiques de flotte publiques",
        "discord": {
          "url": "Serveur Discord",
          "hint": "Connectez un serveur Discord pour y refléter les événements sous forme d'événements planifiés natifs. Les membres peuvent répondre depuis Discord et l'inscription sera resynchronisée vers Fleetyards.",
          "guildId": "ID du serveur Discord",
          "channelId": "ID du salon vocal (facultatif)",
          "webhookUrl": "URL du webhook d'annonce (facultatif)",
          "installBotHint": "Ouvre la page d'installation Discord dans un nouvel onglet — choisissez le serveur vers lequel refléter les événements.",
          "announcementChannel": "Salon d'annonces",
          "announcementChannelHint": "Les nouveaux événements et les rappels avant le début sont publiés ici. Sans salon, ils passent par le webhook. Les événements réservés à des escadrons sont publiés dans les salons de ces escadrons.",
          "officersChannel": "Salon des officiers",
          "officersChannelHint": "Les événements réservés aux officiers sont annoncés ici et nulle part ailleurs sur Discord. Sans salon, ils ne sont pas annoncés sur Discord. Les demandes d'adhésion y sont aussi publiées, avec des boutons pour les accepter ou les refuser.",
          "digestWeekday": "Récapitulatif hebdomadaire",
          "digestWeekdayHint": "Une fois par semaine, chaque salon reçoit la liste des événements des sept prochains jours qu'il peut voir. Laissez vide pour le désactiver.",
          "digestTime": "Heure du récapitulatif",
          "digestTimeHint": "Dans votre fuseau horaire (%{timezone}).",
          "channelMissing": "Ce salon n'existe plus sur Discord ou n'accepte plus de publications. Rien n'est publié tant qu'un autre n'est pas choisi.",
          "missingChannel": "Salon indisponible",
          "postingCodes": {
            "missing_send_messages": "Le bot ne peut pas envoyer de messages sur ce serveur. Utilisez le lien d'installation pour l'autoriser à nouveau.",
            "channel_locked": "Le bot ne peut pas publier dans le salon choisi pour %{names}. Autorisez-le dans les permissions de ce salon.",
            "unknown_channel": "Le salon choisi pour %{names} n'existe plus sur Discord ou n'accepte plus de publications.",
            "channel_shared": "%{names} partage un salon avec des lecteurs à qui ses événements sont cachés. Rien n'y est publié tant que chacun n'a pas son propre salon."
          },
          "statusOk": "Connecté à %{name}",
          "statusCodes": {
            "missing_token": "Le bot Fleetyards n'est pas configuré côté serveur. Contactez un administrateur.",
            "missing_guild": "Saisissez d'abord un ID de serveur Discord.",
            "invalid_token": "Le jeton du bot est invalide. Contactez un administrateur.",
            "bot_not_in_guild": "Le bot n'est pas présent sur ce serveur. Utilisez le lien d'installation pour l'ajouter.",
            "guild_not_found": "Discord ne reconnaît pas cet ID de serveur. Vérifiez la valeur.",
            "discord_error": "Discord a renvoyé une erreur inattendue.",
            "request_failed": "Impossible de joindre Fleetyards. Réessayez."
          }
        },
        "guilded": "Serveur Guilded",
        "homepage": "Page d'accueil",
        "twitch": "Chaîne Twitch",
        "youtube": "Chaîne Youtube",
        "backgroundImage": "Image de fond",
        "ts": "Serveur chat de l'équipe",
        "awaitingConfirmation": "En attente de confirmation par la Flotte",
        "members": {
          "verifiedOrgMember": "Membre vérifié de %{sid}",
          "verifiedOrgMemberChecked": "Membre vérifié de %{sid}, vérifié %{checked}",
          "primary": "Flotte principale?",
          "shipsFilter": {
            "label": "Quels vaisseaux doivent être ajoutés à la Flotte ?",
            "nullablePrompt": "Aucune option sélectionnée",
            "field": "Sélection des vaisseaux",
            "values": {
              "all": "Tous les Vaisseaux",
              "hangar_group": "Tous les vaisseaux dans un Hangar de groupe donné",
              "hide": "Pas de Vaisseaux"
            }
          },
          "hangarGroupId": {
            "field": "Hangar de groupe",
            "label": "Spécifier un Hangar de groupe",
            "nullablePrompt": "Aucun Groupe sélectionné"
          },
          "blueprintsFilter": {
            "label": "Quels plans partager avec la flotte ?",
            "nullablePrompt": "Aucune option sélectionnée",
            "field": "Sélection de plans",
            "values": {
              "all": "Tous les plans que je possède",
              "hide": "Aucun plan"
            }
          },
          "total": "Total : %{count}",
          "joined": "Inscrit le",
          "invited": "Invité",
          "invitedAt": "Invité / Demandé le",
          "requested": "Demande d'adhésion requise",
          "declined": "Refusée",
          "pending": "Invitations et demandes en attente",
          "accepted": "Membres",
          "role": "Rôle",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "Membres",
            "invites": "Invitations"
          }
        },
        "squadrons": {
          "index": "Escadrons",
          "name": "Nom",
          "shortDescription": "Description courte",
          "shortDescriptionHint": "Une ou deux lignes, sur la carte",
          "description": "Description",
          "descriptionHint": "Le texte complet sur la page de l'escadron",
          "noDescription": "Aucune description n’a encore été ajoutée.",
          "icon": "Icône",
          "iconHint": "Image carrée, affichée dans un cercle",
          "team": "Équipe",
          "teamHint": "Une équipe est ouverte à tous — sinon un membre n'appartient qu'à un seul escadron",
          "restrictedToHint": "Seuls ces escadrons peuvent le voir",
          "discordChannel": "Salon Discord",
          "discordChannelHint": "Les événements réservés à cet escadron sont annoncés ici et nulle part ailleurs sur Discord. Sans salon, ils ne sont pas annoncés sur Discord.",
          "notAnnounced": "Pas d'annonce sur Discord pour %{names} : aucun salon Discord n'est configuré.",
          "blockedBy": "Déjà dans l'escadron %{squadron}",
          "color": "Couleur",
          "colorSuggestions": "D'après l'icône :",
          "memberCount": "%{count} membres",
          "members": "Membres",
          "joinedAt": "Date d’adhésion à l’escadron",
          "searchMembers": "Rechercher des membres",
          "availableMembers": "membres disponibles",
          "selectedMembers": "%{count} sélectionnés",
          "rank": "Grade",
          "ranksHint": "Les noms utilisés par chaque escadron de cette flotte. Un grade renommé garde sa place et ses droits.",
          "rankName": "Nom",
          "defaultRank": "Par défaut",
          "defaultRankToggle": "Les nouveaux membres commencent à ce grade",
          "rankRights": {
            "singleHolder": "Un par escadron",
            "managesMembers": "Ajoute et retire les membres de grade inférieur",
            "managesRanks": "Fixe les grades inférieurs au sien"
          }
        },
        "roles": {
          "permanent": "Permanent",
          "default": "Par défaut",
          "defaultToggle": "Les nouveaux membres reçoivent ce rôle",
          "privilegeGroups": {
            "fleet": "Flotte",
            "memberships": "Membres",
            "squadrons": "Escadrons",
            "invites": "Invitations",
            "vehicles": "Véhicules",
            "blueprints": "Plans",
            "roles": "Rôles",
            "inventories": "Inventaires",
            "missions": "Missions",
            "events": "Événements",
            "allies": "Alliés",
            "contracts": "Contrats",
            "payouts": "Répartitions",
            "notifications": "Notifications"
          },
          "privileges": {
            "fleet:update": "Mettre à jour la flotte",
            "fleet:update:images": "Mettre à jour les images",
            "fleet:update:description": "Mettre à jour la description",
            "fleet:delete": "Supprimer la flotte",
            "fleet:manage": "Gérer la flotte",
            "fleet:memberships:read": "Voir les membres",
            "fleet:memberships:create": "Inviter des membres",
            "fleet:memberships:update": "Mettre à jour les membres",
            "fleet:memberships:delete": "Retirer des membres",
            "fleet:memberships:manage": "Gérer les membres",
            "fleet:squadrons:read": "Voir les escadrons",
            "fleet:squadrons:create": "Créer des escadrons",
            "fleet:squadrons:update": "Modifier les escadrons",
            "fleet:squadrons:delete": "Supprimer des escadrons",
            "fleet:squadrons:members:manage": "Gérer les membres d'escadron",
            "fleet:squadrons:manage": "Gérer les escadrons",
            "fleet:invites:read": "Voir les invitations",
            "fleet:invites:create": "Créer des invitations",
            "fleet:invites:update": "Mettre à jour les invitations",
            "fleet:invites:delete": "Supprimer des invitations",
            "fleet:invites:manage": "Gérer les invitations",
            "fleet:vehicles:read": "Voir les véhicules",
            "fleet:vehicles:create": "Ajouter des véhicules",
            "fleet:vehicles:update": "Mettre à jour les véhicules",
            "fleet:vehicles:delete": "Retirer des véhicules",
            "fleet:vehicles:manage": "Gérer les véhicules",
            "fleet:blueprints:read": "Voir les plans",
            "fleet:roles:read": "Voir les rôles",
            "fleet:roles:create": "Créer des rôles",
            "fleet:roles:update": "Mettre à jour les rôles",
            "fleet:roles:delete": "Supprimer des rôles",
            "fleet:roles:manage": "Gérer les rôles",
            "fleet:inventories:read": "Voir les inventaires",
            "fleet:inventories:create": "Créer des inventaires",
            "fleet:inventories:update": "Mettre à jour les inventaires",
            "fleet:inventories:delete": "Supprimer des inventaires",
            "fleet:inventories:manage": "Gérer les inventaires",
            "fleet:missions:read": "Voir les missions",
            "fleet:missions:create": "Créer des missions",
            "fleet:missions:update": "Mettre à jour les missions",
            "fleet:missions:delete": "Supprimer des missions",
            "fleet:missions:manage": "Gérer les missions",
            "fleet:events:read": "Voir les événements",
            "fleet:events:create": "Créer des événements",
            "fleet:events:update": "Mettre à jour les événements",
            "fleet:events:delete": "Supprimer des événements",
            "fleet:events:manage": "Gérer les événements",
            "fleet:allies:read": "Voir les alliés",
            "fleet:allies:create": "Ajouter des alliés",
            "fleet:allies:delete": "Retirer des alliés",
            "fleet:allies:manage": "Gérer les alliés",
            "fleet:contracts:read": "Voir les contrats",
            "fleet:contracts:create": "Créer des contrats",
            "fleet:contracts:update": "Mettre à jour les contrats",
            "fleet:contracts:delete": "Supprimer des contrats",
            "fleet:contracts:manage": "Gérer les contrats",
            "fleet:payouts:read": "Voir les répartitions",
            "fleet:payouts:create": "Enregistrer des répartitions",
            "fleet:payouts:update": "Mettre à jour les répartitions",
            "fleet:payouts:delete": "Supprimer des répartitions",
            "fleet:payouts:manage": "Gérer les répartitions",
            "fleet:notifications:manage": "Gérer les paramètres de notification"
          },
          "name": "Nom",
          "rank": "Rang"
        },
        "inviteUrls": {
          "noExpiration": "N'expire jamais",
          "used": "Utilisé %{count} fois",
          "usedOfLimit": "%{count} sur %{limit} utilisés",
          "expiresIn": "Expire dans %{time}",
          "expired": "Expirée",
          "expiresAfterOptions": {
            "infinite": "Jamais",
            "30_minutes": "30 minutes",
            "1_hour": "1 heure",
            "6_hours": "6 heures",
            "12_hours": "12 heures",
            "1_day": "1 jour",
            "7_days": "7 jours"
          },
          "limitOptions": {
            "1": "1 utilisée",
            "5": "5 utilisées",
            "10": "10 utilisées",
            "25": "25 utilisées",
            "50": "50 utilisées",
            "100": "100 utilisées",
            "infinite": "Pas de limite"
          }
        },
        "calendarSubscription": {
          "intro": "Générez un lien privé que les membres peuvent utiliser pour s'abonner aux événements de cette flotte depuis leur application de calendrier (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Partagez le lien ci-dessus avec vos membres. Ils le collent dans leur application de calendrier (« S'abonner à un calendrier » ou « Ajouter par URL »). Le lien est privé — toute personne le possédant peut voir les événements de cette flotte."
        },
        "notifications": {
          "inAppHint": "Choisissez quels changements du cycle de vie des événements apparaissent comme notifications dans l'application pour les membres de la flotte.",
          "events": {
            "fleet_event": {
              "published": "Événement publié",
              "locked": "Inscriptions verrouillées",
              "unlocked": "Inscriptions rouvertes",
              "starting_soon": "Événement imminent",
              "started": "Événement démarré",
              "completed": "Événement terminé",
              "cancelled": "Événement annulé",
              "archived": "Événement archivé",
              "destroyed": "Événement supprimé"
            },
            "fleet_event_signup": {
              "created": "Inscription ajoutée",
              "withdrawn": "Inscription retirée"
            }
          }
        },
        "inventories": {
          "name": "Nom",
          "description": "Description",
          "location": "Emplacement",
          "visibility": "Visibilité",
          "manager": "Gestionnaire",
          "itemsCount": "Entrées",
          "visibilities": {
            "members_only": "Membres uniquement",
            "officers_only": "Officiers uniquement",
            "squadron_only": "Escadron seulement"
          }
        },
        "allies": "Vaisseaux visibles par les alliés",
        "alliesStats": "Statistiques visibles par les alliés",
        "alliesMembers": "Liste des membres visible par les alliés",
        "squadronsEnabled": "Utiliser les escadrons",
        "listed": "Afficher dans l’annuaire des flottes",
        "listedInfo": "Une flotte vérifiée et publique comptant au moins deux membres figure dans l’annuaire des flottes. Une flotte privée n’y figure jamais.",
        "alignment": "Alignement",
        "alignments": {
          "lawful": "Légal",
          "neutral": "Neutre",
          "outlaw": "Hors-la-loi"
        },
        "activities": {
          "bounty_hunting": "Chasse de primes",
          "engineering": "Ingénierie",
          "exploration": "Exploration",
          "freelancing": "Freelance",
          "infiltration": "Infiltration",
          "medical": "Médical",
          "piracy": "Piraterie",
          "resources": "Ressources",
          "scouting": "Reconnaissance",
          "security": "Sécurité",
          "smuggling": "Contrebande",
          "social": "Social",
          "trading": "Commerce",
          "transport": "Transport"
        },
        "commitments": {
          "casual": "Occasionnel",
          "regular": "Régulier",
          "hardcore": "Hardcore"
        },
        "rsiProfile": {
          "info": "Synchronisé une fois par jour depuis la page RSI de ton organisation. Modifie ces informations sur RSI.",
          "primaryActivity": "Activité principale",
          "secondaryActivity": "Activité secondaire",
          "language": "Langue",
          "commitment": "Engagement",
          "recruiting": "Recrute",
          "roleplay": "Jeu de rôle"
        },
        "contractCovers": {
          "transport": "Visuel transport",
          "procurement": "Visuel approvisionnement",
          "crafting": "Visuel fabrication"
        }
      },
      "hangarGroup": {
        "name": "Nom",
        "color": "Couleur ",
        "sort": "Ordre de Tri",
        "public": "Afficher sur le hangar publique ?"
      },
      "source": "Source",
      "loadout": {
        "namePlaceholder": "Nom de la configuration...",
        "urlPlaceholder": "Coller l'URL de configuration erkul.games ou spviewer.eu...",
        "empty": "Aucune configuration pour le moment. Créez-en une pour commencer.",
        "active": "Active",
        "activate": "Définir comme active",
        "planOn": "Planifiez votre configuration sur"
      },
      "model": {
        "hidden": "Masqué ?",
        "active": "Actif ?",
        "inGame": "Dans le jeu ?",
        "adiMap": "Carte ADI ?",
        "ground": "Véhicule terrestre ?",
        "productionNote": "Note de production",
        "rsiId": "RSI ID",
        "length": "Longueur",
        "beam": "Largeur",
        "height": "Hauteur",
        "scKey": "SC Key",
        "price": "Prix",
        "pledgePrice": "Prix de Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masse",
        "minCrew": "Équipage min.",
        "maxCrew": "Équipage max.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Vitesse max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Cargaison",
        "cargoHolds": "Soutes à cargaison",
        "hydrogenFuelTankSize": "Taille du réservoir hydrogène",
        "hydrogenFuelTanks": "Réservoirs de carburant hydrogène",
        "quantumFuelTankSize": "Taille du réservoir Quantum",
        "quantumFuelTanks": "Réservoirs de carburant Quantum",
        "externalFuelTanks": "Réservoirs de carburant externes",
        "externalFuelTanksTotal": "Capacité totale",
        "externalFuelTanksCount": "Nacelles",
        "refuelBoom": "Perche de ravitaillement",
        "refuelBoomArm": "Bras",
        "refuelBoomNozzle": "Buse",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Lacet boosté",
        "pitchBoosted": "Tangage boosté",
        "rollBoosted": "Roulis boosté",
        "variants": "Variantes",
        "manufacturer": "Fabricant",
        "loaners": "Prêts",
        "paints": "Peintures",
        "modules": "Modules",
        "modulePackages": "Paquets de module",
        "upgrades": "Kits d'Amélioration",
        "brochure": "Brochure",
        "holo": "Holo",
        "angledView": "Vue angulaire",
        "angledViewColored": "Vue angulaire colorée",
        "sideView": "Vue de côté",
        "sideViewColored": "Vue de côté colorée",
        "frontView": "Vue de face",
        "frontViewColored": "Vue de face colorée",
        "topView": "Vue de dessus",
        "topViewColored": "Vue de dessus colorée",
        "onSale": "En Vente",
        "playerOwnable": "Possédable par un joueur ?",
        "ingameOnly": "Uniquement en jeu",
        "canLandOnPlanets": "Peut se poser sur les planètes",
        "cannotLandOnPlanets": "Ne peut pas se poser sur les planètes",
        "salesPage": "Page des Ventes",
        "addons": "Kits de Modules et d'Amélioration",
        "storeImage": "Image du magasin",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Postes d'équipage",
        "needsCuration": "Nécessite une curation",
        "curatedPosition": "Poste curé manuellement",
        "baseModel": "Modèle de base",
        "fleetchartOffsetLength": "Décalage longueur du diagramme de flotte",
        "fleetchartOffsetBeam": "Décalage largeur du diagramme de flotte",
        "extendedLength": "Longueur étendue",
        "extendedBeam": "Largeur étendue",
        "extendedHeight": "Hauteur étendue",
        "extendedFleetchartOffsetLength": "Décalage longueur étendue du diagramme de flotte",
        "extendedFleetchartOffsetBeam": "Décalage largeur étendue du diagramme de flotte",
        "defaultHolo": "Holo par défaut",
        "extendedHolo": "Holo étendu",
        "extendedTopView": "Vue de dessus étendue",
        "extendedTopViewColored": "Vue de dessus étendue colorée",
        "extendedSideView": "Vue de côté étendue",
        "extendedSideViewColored": "Vue de côté étendue colorée",
        "extendedFrontView": "Vue de face étendue",
        "extendedFrontViewColored": "Vue de face étendue colorée",
        "extendedAngledView": "Vue en biais étendue",
        "extendedAngledViewColored": "Vue en biais étendue colorée",
        "landedHolo": "Holo posé",
        "landedTopView": "Vue de dessus posée",
        "landedSideView": "Vue de côté posée",
        "landedFrontView": "Vue de face posée",
        "landedAngledView": "Vue en biais posée",
        "landedTopViewColored": "Vue de dessus posée colorée",
        "landedSideViewColored": "Vue de côté posée colorée",
        "landedFrontViewColored": "Vue de face posée colorée",
        "landedAngledViewColored": "Vue en biais posée colorée",
        "state": {
          "flight": "En vol",
          "extended": "Déployé",
          "landed": "Au sol"
        },
        "productionStatus": {
          "in-production": "En cours de production",
          "in-concept": "En concept",
          "ready": "Hangar prêt",
          "flight-ready": "Le vol est prêt",
          "announced": "Annoncée"
        },
        "carriedBy": "Peut être transporté par",
        "landedLength": "Longueur au sol",
        "landedBeam": "Largeur au sol",
        "landedHeight": "Hauteur au sol",
        "landedFleetchartOffsetLength": "Décalage de longueur posé",
        "landedFleetchartOffsetBeam": "Décalage de largeur posé"
      },
      "models": {
        "extraColumns": "Colonnes",
        "table": {
          "columns": {
            "storeImage": "Image",
            "storeImageWide": "Image large",
            "rsiStoreImage": "Image RSI",
            "rsiStoreImageWide": "Image RSI large",
            "angledView": "Image 3D",
            "angledViewWide": "Image 3D large",
            "rsiId": "RSI ID",
            "hidden": "Masqué",
            "active": "Actif",
            "createdAt": "Créé le",
            "updatedAt": "Mis à jour le",
            "manufacturerName": "Fabricant",
            "length": "Longueur",
            "beam": "Largeur",
            "height": "Hauteur",
            "mass": "Masse",
            "cargo": "Cargaison",
            "quantumFuelTankSize": "Carburant Quantum",
            "hydrogenFuelTankSize": "Carburant hydrogène",
            "minCrew": "Équipage",
            "maxCrew": "Équipage max.",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Vitesse max.",
            "groundMaxSpeed": "Vitesse au sol",
            "focus": "Spécialisation",
            "productionStatus": "Statut de production",
            "price": "Prix",
            "pledgePrice": "Prix de Pledge"
          }
        }
      },
      "metrics": {
        "info": "Information",
        "levels": "Niveaux",
        "views": "Vues",
        "base": "Base",
        "crew": "Équipe",
        "speed": "Vitesse",
        "cargo": "Cargaison",
        "combat": "Combat",
        "hardpoints": "Points d'attache"
      },
      "flight": {
        "boostCapacitor": "Condensateur de boost",
        "boostCapacity": "Capacité",
        "boostRegen": "Régénération",
        "boostRegenDelay": "Délai de régénération",
        "boostRamp": "Montée / descente",
        "title": "Vol",
        "scm": "croisière de combat",
        "nav": "croisière",
        "boost": "Boost",
        "boostSub": "postcombustion",
        "reverse": "Marche arrière",
        "maneuverability": "Maniabilité",
        "fuel": "Carburant",
        "fuelHydrogen": "Hydrogène",
        "fuelQuantum": "Quantum",
        "hint": "La maniabilité boostée dépend des pips alloués au moteur ; tout est à zéro lorsque le moteur n'est pas alimenté."
      },
      "base": {
        "price": "Prix",
        "priceInGame": "En jeu",
        "pricePledge": "Pledge",
        "availability": "Disponibilité"
      },
      "availability": {
        "title": "Disponibilité",
        "buy": "Achat",
        "rent": "Location",
        "sell": "Vente",
        "cheapest": {
          "buy": "Achat le moins cher",
          "rent": "Location la moins chère"
        },
        "bestSale": "Meilleur prix de vente",
        "allLocations": "Tous les emplacements",
        "locations": {
          "one": "%{count} emplacement",
          "other": "%{count} emplacements"
        },
        "empty": "Aucun emplacement d'achat ou de location connu.",
        "timeRange": {
          "1-day": "1 jour",
          "3-days": "3 jours",
          "7-days": "7 jours",
          "30-days": "30 jours"
        }
      },
      "cargo": {
        "title": "Cargaison",
        "holdsSub": "réparties sur %{count} soutes",
        "maxContainerSub": "plus grande caisse acceptée",
        "containers": "Capacité en conteneurs",
        "hint": "Nombre maximal de conteneurs de chaque taille pouvant tenir sur les grilles de cargaison ; la barre indique la part de la capacité totale ainsi remplie."
      },
      "fuelTanks": {
        "capacitySub": "réparti sur %{count} nacelles",
        "podsSub": "supports externes",
        "components": "Types de nacelles",
        "perPod": "par nacelle",
        "hint": "Carburant transporté dans des nacelles montées sur des points d'attache externes ; la barre indique la part de chaque type dans la capacité totale."
      },
      "refuelBoom": {
        "fuelFlowSub": "transfert d'hydrogène",
        "quantumFlowSub": "transfert de quantum",
        "captureRadiusSub": "tolérance d'amarrage",
        "equipment": "Équipement",
        "hint": "Débits de transfert du bras de ravitaillement et tolérance d'amarrage de sa buse."
      },
      "combat": {
        "title": "Combat",
        "openPenetrationCheck": "Test de pénétration",
        "dps": "DPS en rafale",
        "dpsSub": "%{count} armes",
        "sustained": "DPS soutenu",
        "sustainedSub": "avec régénération et chaleur",
        "alpha": "Alpha",
        "alphaSub": "par salve",
        "weapons": "Armes",
        "missileDamage": "Dégâts des missiles",
        "armedMissiles": "Missiles armés",
        "armedMissilesSub": "%{cooldown} s entre deux tirs",
        "composition": "Composition des dégâts",
        "damagePhysical": "Physique",
        "damageEnergy": "Énergie",
        "damageDistortion": "Distorsion",
        "damageThermal": "Thermique",
        "controlComposition": "DPS par contrôle",
        "controlGroups": {
          "pilot": "Pilote",
          "manned": "Tourelle habitée",
          "remote": "Tourelle téléopérée",
          "pds": "Défense rapprochée"
        },
        "hint": "DPS de l'équipement par défaut. Le DPS soutenu tient compte de la régénération de la réserve d'énergie de chaque arme et de son cycle de surchauffe. Les missiles sont exclus."
      },
      "power": {
        "title": "Répartition de l'énergie",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Réinitialiser",
        "auto": "Auto",
        "aimAssist": "Aide à la visée",
        "cooling": "Refroidissement",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Cliquez pour changer d'axe (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segments",
        "hint": "Répartissez l'énergie entre les systèmes. Le DPS soutenu des armes dépend de l'énergie qu'elles reçoivent ; le reste est équilibré automatiquement.",
        "families": {
          "weapon": "Armes",
          "shield": "Boucliers",
          "engine": "Moteur",
          "radar": "Radar",
          "coolers": "Refroidisseurs",
          "qdrive": "Moteur quantique",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Support vital",
          "miningLaser": "Laser de minage",
          "salvage": "Récupération",
          "tractorBeam": "Rayon tracteur",
          "towingbeam": "Rayon de remorquage"
        }
      },
      "defense": {
        "title": "Défense",
        "shieldHp": "HP des boucliers",
        "shieldHpSub": "%{count} générateurs",
        "shieldRegen": "Régénération",
        "shieldResistances": "Résistance",
        "shieldAbsorption": "Absorption",
        "shieldFaces": "Faces du bouclier",
        "armor": "Blindage",
        "deflection": "Déflexion",
        "armorReduction": "Réduction des dégâts",
        "armorSelfResistance": "Résistance propre",
        "armorSignature": "Signature",
        "countermeasures": "Contre-mesures",
        "countermeasureDuration": "Durée",
        "countermeasure": {
          "decoy": "Leurre",
          "noise": "Brouillage"
        },
        "damageType": {
          "physical": "Phys",
          "energy": "Énergie",
          "distortion": "Distors.",
          "thermal": "Thermique"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valeurs de bouclier, de blindage et de contre-mesures de l'équipement par défaut. Une absorption inférieure à 100 % signifie que ce type de dégâts atteint la coque alors que les boucliers sont encore actifs.",
        "openDeflectionCheck": "Test de déflexion"
      },
      "penetrationCheck": {
        "title": "Test de pénétration",
        "intro": "— quels vaisseaux ses armes peuvent-elles percer ?",
        "noWeapons": "Cette configuration n'embarque aucun canon avec des dégâts par tir à tester.",
        "weapons": "Armes",
        "shieldHealth": "Santé du bouclier de la cible",
        "armorHealth": "Santé du blindage de la cible",
        "ship": "Vaisseau",
        "hoverHint": "Survolez un vaisseau pour le détail par arme.",
        "note": "Chaque canon sélectionné est testé contre les boucliers et la déflexion du blindage de chaque vaisseau selon les mêmes règles que le test de déflexion ; un vaisseau est percé dès que l'un d'eux passe, et classé selon le canon qui s'en approche le plus. Les vaisseaux sans blindage sont exclus, faute de seuil à franchir.",
        "sortBy": "Trier par",
        "sort": {
          "margin": "Marge",
          "ttk": "Temps de destruction"
        },
        "ttk": "TTK",
        "effectiveHp": "PV effectifs",
        "shieldsDown": "Boucliers tombés",
        "ttkNote": "Le temps de destruction utilise les dégâts soutenus par seconde des canons sélectionnés, avec la répartition d'énergie actuelle, à partir de la santé du bouclier et du blindage réglée ci-dessus. Les boucliers encaissent les dégâts qu'ils absorbent, moins leur résistance, et transmettent le reste au blindage, qui l'encaisse jusqu'à rompre puis le transmet à la coque ; la distorsion n'épuise que les boucliers. Les boucliers ne se régénèrent que tant que chaque canon est en pause plus longtemps que leur délai de régénération, et une fois tombés ils le restent. Les PV effectifs sont les dégâts bruts d'un type nécessaires pour détruire le vaisseau, sans déflexion. Les rayons, marqués TTK, ne comptent que pour le temps de destruction : le blindage ne les dévie jamais et, sans alpha par tir, ils n'entrent pas dans la marge. Les missiles sont exclus."
      },
      "deflectionCheck": {
        "title": "Test de déflexion",
        "intro": "— quelles armes percent ses défenses ?",
        "noArmor": "Ce vaisseau ne porte aucun blindage, rien n'est donc dévié.",
        "allSizes": "Toutes",
        "deflected": "dévié",
        "pierce": "percent",
        "weapon": "Arme",
        "boundary": "Seuil de déflexion",
        "alpha": "Alpha",
        "threshold": "Seuil franchi",
        "absorbed": "absorbé",
        "versus": "vs",
        "hoverHint": "Survolez une arme pour le détail par type.",
        "note": "L'alpha est comparé par projectile, après l'absorption du bouclier — une arme perce dès qu'elle dépasse la déflexion sur un type de dégâts. Les types que les boucliers absorbent totalement n'atteignent jamais le blindage : ils sont donc listés comme absorbés plutôt que déviés, arrêtés par le bouclier et non par la coque. L'absorption du bouclier est interpolée sur sa plage min–max publiée en fonction de sa santé, et la déflexion du blindage évolue linéairement avec la santé du blindage. Les faisceaux laser sont exclus — ils infligent des dégâts continus, il n'y a donc pas d'alpha par tir à tester.",
        "margin": "Marge",
        "reachesArmor": "Atteint le blindage",
        "stoppedByShields": "Absorbé par le bouclier",
        "verdict": {
          "absorbed": "Absorbé",
          "deflected": "Dévié",
          "pierces": "Percé"
        },
        "shieldHealth": "Santé du bouclier",
        "armorHealth": "Santé du blindage",
        "absorb": "Absorb.",
        "defl": "Défl.",
        "type": "Type",
        "size": "Taille"
      },
      "hull": {
        "category": {
          "vital": "Vital",
          "secondary": "Secondaire",
          "breakable": "Destructible",
          "subpart": "Sous-pièces",
          "cosmetic": "Cosmétique"
        },
        "composition": "Composition de la coque",
        "door": "Porte",
        "doors": "Portes",
        "doorsNote": "Les portes intérieures destructibles forment une zone à part — elles disposent de leur propre santé et ne comptent pas dans les HP de la coque.",
        "doorsSub": "%{count} destructibles",
        "hint": "Les HP de la coque sont la somme de la santé de toutes les pièces.",
        "hullHp": "HP de la coque",
        "hullHpSub": "total sur toutes les pièces",
        "integrity": "Intégrité de la coque",
        "noHp": "aucun HP",
        "parts": "Pièces de la coque",
        "partsNote": "Les pièces sont classées par santé ; les pièces cosmétiques (portes, échelles, volets) n'ont pas de santé propre. Les fichiers du jeu n'exposent aucun lien parent/enfant, il s'agit donc d'une liste à plat plutôt que d'un arbre structurel.",
        "partsSub": "réparties sur %{count} catégories",
        "partsTree": "Pièces · damageMax",
        "showParts": "Afficher les pièces de la coque",
        "title": "Coque",
        "totalHp": "HP totaux de la coque"
      },
      "manufacturer": {
        "longName": "Nom complet",
        "code": "Code",
        "logo": "Logo",
        "logoOverridden": "Logo (remplacé)",
        "icon": "Icône (fichiers du jeu)",
        "iconOverridden": "Icône (remplacée)",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Titre",
        "body": "Contenu",
        "discordParts": "Messages Discord",
        "socialParts": "Messages sociaux",
        "link": "Lien",
        "notifyUsers": "Notification dans l'app",
        "postDiscord": "Canal Discord des mises à jour",
        "postBluesky": "Bluesky",
        "postX": "X.com",
        "schedule": "Planifier",
        "publishAt": "Envoyer le"
      },
      "fundingGoal": {
        "title": "Titre",
        "description": "Description",
        "amount": "Montant",
        "currency": "Devise",
        "effectiveFrom": "En vigueur à partir du",
        "endedAt": "Terminé le"
      },
      "supporterContribution": {
        "name": "Nom du soutien",
        "user": "Compte lié",
        "amount": "Montant",
        "currency": "Devise",
        "anonymous": "Anonyme",
        "recurring": "Récurrent",
        "startedAt": "Démarré le",
        "endedAt": "Terminé le",
        "payerEmail": "E-mail du payeur",
        "claimKey": "Jeton de soutien",
        "linkedVia": "Lié via",
        "source": "Source",
        "note": "Note interne",
        "stats": {
          "total": "Total",
          "count": "Contributions",
          "currentMonth": "Ce mois-ci",
          "currentMonthCount": "%{count} contributions",
          "recurringCount": "Récurrentes",
          "anonymousCount": "Anonymes"
        },
        "chart": {
          "contributions": "Contributions",
          "goal": "Objectif"
        }
      },
      "itemPrice": {
        "price": "Prix",
        "location": "Emplacement",
        "locationUrl": "URL de l'emplacement"
      },
      "video": {
        "url": "URL",
        "videoType": "Type"
      },
      "modelModule": {
        "name": "Nom",
        "description": "Description",
        "price": "Prix",
        "pledgePrice": "Prix Pledge",
        "productionStatus": "Statut de Production",
        "scKey": "SC Key",
        "storeImage": "Image de Boutique",
        "active": "Actif ?",
        "hidden": "Caché ?"
      },
      "dockAddition": {
        "model": "Vaisseau",
        "hint": "Vaisseaux que ce poste accueille et que sa classe ne couvre pas.",
        "empty": "vaisseaux nommés"
      },
      "dockCapacity": {
        "ladder": "Échelle",
        "size": "Classe",
        "quantity": "Combien",
        "display": "Afficher comme étiquette",
        "hint": "Ce pour quoi le poste est conçu. Les entrées sont des alternatives, pas une somme.",
        "empty": "entrées de capacité"
      },
      "dockCapacityLadders": {
        "ship": "Vaisseaux",
        "vehicle": "Véhicules"
      },
      "vehicleSizes": {
        "extra_extra_small": "Minuscule (XXS)",
        "extra_small": "Très petit (XS)",
        "small": "Petit (S)",
        "medium": "Moyen (M)",
        "large": "Grand (L)",
        "extra_large": "Très grand (XL)",
        "extra_extra_large": "Énorme (XXL)"
      },
      "dock": {
        "name": "Nom",
        "dockType": "Type de quai",
        "shipSize": "Taille du vaisseau",
        "access": "Accès",
        "length": "Longueur",
        "beam": "Largeur",
        "height": "Hauteur",
        "unmeasured": "non mesuré"
      },
      "modelPosition": {
        "name": "Nom",
        "positionType": "Type de poste",
        "source": "Source",
        "position": "Ordre de tri",
        "types": {
          "pilot": "Pilote",
          "copilot": "Copilote",
          "turret_gunner": "Artilleur de tourelle",
          "engineer": "Ingénieur",
          "gunner": "Artilleur",
          "loadmaster": "Chef de soute",
          "passenger": "Passager",
          "operator": "Opérateur",
          "custom": "Personnalisé"
        }
      },
      "modelUpgrade": {
        "name": "Nom",
        "description": "Description",
        "pledgePrice": "Prix de Pledge",
        "active": "Actif ?",
        "hidden": "Masqué ?"
      },
      "modelModulePackage": {
        "name": "Nom",
        "description": "Description",
        "pledgePrice": "Prix de Pledge",
        "modules": "Modules",
        "active": "Actif ?",
        "hidden": "Masqué ?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)"
      },
      "modelLoaner": {
        "hidden": "Masqué ?",
        "loanerModel": "Modèle de prêt"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Masqué ?",
        "active": "Actif ?",
        "onSale": "En vente",
        "pledgePrice": "Prix de Pledge",
        "productionStatus": "Statut de production",
        "productionNote": "Note de production",
        "copyHint": "Sélectionnez le vaisseau cible vers lequel copier cette peinture. Les données de la peinture ne sont pas modifiées lors de la copie.",
        "bulkCopyHint": "Sélectionnez le vaisseau cible vers lequel copier ces %{count} peintures. Les données des peintures ne sont pas modifiées lors de la copie.",
        "copySameModel": "Le vaisseau cible doit être différent du vaisseau source."
      },
      "component": {
        "temperature": {
          "minCooling": "Refroidit dès",
          "overheat": "Surchauffe à",
          "warning": "Alerte à",
          "recovery": "Récupère à",
          "misfireRange": "Plage de défaillance",
          "irStart": "IR dès",
          "irPerKelvin": "IR par K"
        },
        "misfire": {
          "heat": "Chaleur",
          "distortion": "Distorsion",
          "damage": "Dégâts",
          "wear": "Usure",
          "window": "Fenêtre",
          "hint": "Le niveau de chaque état à partir duquel le composant peut commencer à défaillir, tel que le donnent les fichiers du jeu."
        },
        "availability": {
          "retired": "Les prix sont suivis pour la version sur laquelle est le catalogue, et cette pièce n'en fait pas partie.",
          "craftedOnly": "Aucun terminal ne le vend : il se fabrique à partir de la recette ci-dessous.",
          "none": "Aucun terminal ne l'achète ni ne le vend."
        },
        "notRecordedYet": "Enregistré seulement depuis le début du suivi, un composant peut donc n'avoir rien.",
        "size": "Taille : %{size}",
        "grade": "Grade",
        "hidden": "Masqué ?",
        "componentClass": "Classe de composant",
        "componentType": "Type de composant",
        "componentSubType": "Sous-type de composant",
        "itemType": "Type d'objet",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "Classe",
        "category": "Catégorie",
        "subType": "Sous-type",
        "retired": "Absent de la version actuelle",
        "noMetrics": "Aucune donnée n'est enregistrée pour ce composant.",
        "durability": {
          "health": "Santé",
          "mass": "Masse",
          "physical": "Physique",
          "energy": "Énergie",
          "distortion": "Distorsion",
          "thermal": "Thermique",
          "biochemical": "Biochimique",
          "stun": "Étourdissement",
          "repairTime": "Temps de réparation",
          "repairsTo": "Répare jusqu'à",
          "maxRepairs": "Réparations max.",
          "disableAt": "Désactivé à",
          "warningAt": "Alerte à",
          "recoversBelow": "Récupère sous",
          "decayRate": "Taux de dissipation",
          "decayDelay": "Délai de dissipation"
        },
        "durabilityChanges": {
          "health": "Santé",
          "mass": "Masse (kg)",
          "resistancesPhysical": "Dégâts physiques subis",
          "resistancesEnergy": "Dégâts d'énergie subis",
          "resistancesDistortion": "Dégâts de distorsion subis",
          "resistancesThermal": "Dégâts thermiques subis",
          "resistancesBiochemical": "Dégâts biochimiques subis",
          "resistancesStun": "Dégâts d'étourdissement subis",
          "selfRepairTime": "Temps d'autoréparation (s)",
          "selfRepairHealthRatio": "L'autoréparation rétablit à",
          "selfRepairMaxRepairs": "Autoréparations max.",
          "distortionMaximum": "Seuil de coupure par distorsion",
          "distortionWarningRatio": "Seuil d'alerte de distorsion",
          "distortionRecoveryRatio": "Seuil de récupération de distorsion",
          "distortionDecayRate": "Taux de dissipation de distorsion (/s)",
          "distortionDecayDelay": "Délai de dissipation de distorsion (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "Légende",
          "slotTaken": "Emplacement pris",
          "slotAvailable": "Emplacement disponible"
        },
        "size": "Taille",
        "rackSize": "Taille de la rampe",
        "details": "Détails",
        "group": "Groupe",
        "thrusters": {
          "thrust": "Poussée",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "mode": "Mode",
          "vtolOnly": "VTOL uniquement",
          "vectorPitch": "Vectorisation tangage",
          "vectorYaw": "Vectorisation lacet"
        },
        "refuelBoom": {
          "captureRadius": "Rayon de capture",
          "fuelFlowRate": "Débit de carburant",
          "quantumFuelFlowRate": "Débit de carburant Quantum"
        },
        "controllers": {
          "faceType": "Type de bouclier",
          "faces": {
            "bubble": "Bulle",
            "quadrant": "Quadrants"
          },
          "reconfigurationCooldown": "Reconfiguration",
          "armedMissiles": "Missiles armés",
          "launchCooldown": "Délai de lancement",
          "lockAngle": "Angle de verrouillage"
        },
        "countermeasureStats": {
          "duration": "Durée",
          "spawnDelay": "Se déploie après",
          "infrared": "Signature IR",
          "electromagnetic": "Signature EM",
          "crossSection": "Section efficace"
        },
        "turrets": {
          "turnRate": "Vitesse de rotation",
          "control": "Contrôle",
          "yawRange": "Amplitude en lacet",
          "pitchRange": "Amplitude en tangage",
          "limitsVary": "selon la rotation",
          "gunPorts": "Emplacements d'armes"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS en rafale",
          "sustainedDps": "DPS soutenu",
          "efficiency": "Efficacité",
          "penetration": "Pénétration",
          "fireRate": "Cadence de tir",
          "speed": "Vitesse",
          "range": "Portée",
          "ammo": "Munitions",
          "ammoCost": "Coût des munitions",
          "magazineDamage": "Dégâts du chargeur",
          "timeToEmpty": "Temps pour vider",
          "spread": "Dispersion",
          "spreadFirstShot": "Dispersion au premier tir",
          "spreadPerShot": "Dispersion/tir",
          "spreadRecovery": "Récupération de dispersion",
          "pool": "Réserve d'énergie",
          "maxRegen": "Régén. max/s",
          "costPerShot": "Énergie/tir",
          "heatPerShot": "Chaleur/tir",
          "heatPerSecond": "Chaleur/s",
          "gimbalFireRate": "Cadence (gimbal)",
          "gimbalSpread": "Dispersion (gimbal)",
          "spreadMin": "min.",
          "spreadMax": "max.",
          "aimAssist": "Aide à la visée",
          "closeAimAssist": "Aide à la visée rapprochée",
          "chargeTime": "Temps de charge",
          "fullDamageRange": "Portée DMG max",
          "zeroDamageRange": "Portée DMG nuls",
          "damagePhysical": "Physique",
          "damageEnergy": "Énergie",
          "damageDistortion": "Distorsion",
          "damageThermal": "Thermique"
        },
        "missiles": {
          "damage": "Dégâts",
          "speed": "Vitesse",
          "range": "Portée",
          "lockRange": "Portée de verrouillage",
          "lockTime": "Temps de verrouillage",
          "trackingSignal": "Suivi",
          "lockAngle": "Cône de verrouillage",
          "signalResilience": "Résistance au signal",
          "boostPhase": "Phase de propulsion",
          "terminalPhase": "Phase terminale",
          "lifetime": "Durée de vie",
          "fuel": "Carburant",
          "dumbfire": "Tir non guidé",
          "dumbfireAllowed": "Autorisé",
          "dumbfireBlocked": "Non autorisé",
          "blastRadius": "Rayon d'explosion",
          "armTime": "Délai d'armement",
          "safetyDistance": "Distance de sécurité"
        },
        "bombs": {
          "maxDropAngle": "Angle de largage max."
        },
        "missileRacks": {
          "launchDelay": "Délai de lancement",
          "ignition": "Allumage du moteur",
          "ignitesOnRack": "Sur le rail",
          "ignitesAfterRelease": "Après largage"
        },
        "tractorBeams": {
          "maxForce": "Force max.",
          "minForce": "Force min.",
          "range": "Portée",
          "cone": "Cône",
          "tetherBreak": "Rupture du lien",
          "cargoForce": "Force cargaison",
          "cargoRange": "Portée cargaison",
          "towForce": "Force de remorquage",
          "towDistance": "Portée de remorquage",
          "quantumTowMass": "Masse max. en QT",
          "rotationSpeed": "Rotation",
          "moveSpeed": "Vitesse de déplacement"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Temps de régén.",
          "downedRegenDelay": "Délai après chute",
          "damagedRegenDelay": "Délai après dégâts",
          "resistancePhysical": "Rés. phys.",
          "resistanceEnergy": "Rés. énergie",
          "resistanceDistortion": "Rés. distors.",
          "decay": "Dissipation",
          "absorption": {
            "physical": "Absorption physique",
            "energy": "Absorption énergie",
            "distortion": "Absorption distorsion"
          }
        },
        "coolers": {
          "coolingRate": "Refroidissement"
        },
        "powerPlants": {
          "output": "Puissance",
          "pips": "Pips"
        },
        "flightControllers": {
          "scmSpeed": "Vitesse SCM",
          "boostSpeed": "Vitesse de boost",
          "navSpeed": "Vitesse Nav",
          "rotation": "Tangage / Lacet / Roulis",
          "boostedRotation": "Tangage / Lacet / Roulis en boost",
          "boostCapacity": "Capacité de boost",
          "boostRegen": "Régénération du boost",
          "boostRegenDelay": "Délai de régénération du boost",
          "boostRamp": "Montée / descente du boost"
        },
        "quantumDrives": {
          "speed": "Vitesse",
          "range": "Portée",
          "fuelConsumption": "Consommation",
          "spoolUpTime": "Amorçage",
          "cooldownTime": "Refroidissement",
          "splineSpeed": "Orbite",
          "accel": "Accél.",
          "engageSpeed": "Vitesse d'engagement",
          "calibrationRate": "Vitesse de calibrage",
          "disconnectRange": "Distance de déconnexion",
          "interdictionTime": "Durée d'interdiction",
          "splineAccel": "Accélération en orbite",
          "splineSpoolUpTime": "Démarrage en orbite",
          "splineCooldownTime": "Refroidissement en orbite",
          "splineInterdictionTime": "Interdiction en orbite",
          "jumpHeat": "Chaleur de saut"
        },
        "jumpDrives": {
          "fuelEfficiency": "Efficacité du carburant",
          "alignRate": "Taux d'alignement",
          "tuneRate": "Taux de réglage",
          "alignDecay": "Perte d'alignement",
          "tuneDecay": "Perte de réglage",
          "exitSpeed": "Vitesse de sortie",
          "maxTunnelSpeed": "Vitesse max. dans le tunnel",
          "respoolTime": "Réarmement"
        },
        "radar": {
          "aimAssistRange": "Portée d'assistance",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "Détection passive",
          "active": "Détection active",
          "aimAssistBuffer": "Marge d'assistance",
          "sensitivityModifier": "Modificateur de sensibilité",
          "contactGroups": {
            "GroundVehicle": "Véhicules terrestres"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "Physique",
          "energy": "Énergie",
          "distortion": "Distorsion",
          "thermal": "Thermique",
          "deflectPhysical": "Défl. phys.",
          "deflectEnergy": "Défl. énergie",
          "selfPhysical": "Rés. propre phys.",
          "selfEnergy": "Rés. propre énergie"
        },
        "fuelIntakes": {
          "pushRate": "Débit d'admission",
          "minRate": "Débit min."
        },
        "sources": {
          "game_files": "Fichiers du jeu",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vue",
          "compact": "Compacte",
          "expanded": "Détaillée"
        },
        "fuelTanks": {
          "hydrogen": "Réservoir de carburant hydrogène",
          "quantum": "Réservoir de carburant Quantum"
        },
        "jumpDrive": "Moteur de saut",
        "maxContainerSize": "Taille max. de conteneur",
        "groups": {
          "avionic": "Avioniques",
          "system": "Systèmes",
          "propulsion": "Propulsion",
          "thruster": "Propulseur",
          "weapon": "Armes",
          "defense": "Défense",
          "other": "Autre",
          "auxiliary": "Auxiliaire",
          "seat": "Sièges",
          "external_fuel_tank": "Réservoirs de carburant externes",
          "refuel_boom": "Perche de ravitaillement"
        },
        "types": {
          "radar": "Radar",
          "computers": "Ordinateurs",
          "power_plants": "Générateurs",
          "coolers": "Refroidisseurs",
          "shield_generators": "Générateurs de bouclier",
          "fuel_intakes": "Consommation de carburant",
          "fuel_tanks": "Réservoirs de carburant",
          "quantum_drives": "Moteurs quantiques",
          "jump_modules": "Modules de Saut",
          "jumpdrive": "Modules de saut",
          "quantum_fuel_tanks": "Réservoirs de carburant quantique",
          "main_thrusters": "Propulseurs Principaux",
          "maneuvering_thrusters": "Propulseurs de manœuvre",
          "weapons": "Armes",
          "turrets": "Tourelles",
          "missiles": "Missiles",
          "utility_items": "Objets Utilitaires",
          "utility": "Objets utilitaires",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Sélectionner un module —",
        "selectModule": "Sélectionner un module",
        "moduleStock": "Tel que livré",
        "moduleStockHint": "Emplacement tel que le vaisseau est livré",
        "categories": {
          "radar": "Radar",
          "armor": "Blindage",
          "relay": "Relais",
          "countermeasures": "Contre-mesures",
          "lifesupport": "Support vital",
          "selfdestruct": "Autodestruction",
          "batteries": "Batteries",
          "computers": "Ordinateurs",
          "powerplant": "Réacteurs",
          "cooler": "Refroidisseurs",
          "module": "Modules",
          "shieldgenerator": "Générateurs de boucliers",
          "fuel_intakes": "Prises de carburant",
          "fueltanks": "Réservoirs de carburant",
          "external_fuel_tanks": "Réservoirs de carburant externes",
          "refuel_boom": "Perche de ravitaillement",
          "quantumdrive": "Moteurs Quantum et modules de saut",
          "jump_modules": "Modules de saut",
          "jumpdrive": "Modules de saut",
          "quantum_fuel_tanks": "Réservoirs de carburant Quantum",
          "main_thrusters": "Propulseurs principaux",
          "maneuvering_thrusters": "Propulseurs de manœuvre",
          "retro_thrusters": "Rétro-propulseurs",
          "vtol_thrusters": "Propulseurs VTOL",
          "weapons": "Armes",
          "weapon_mounts": "Supports d'armes",
          "turret": "Tourelles",
          "missiles": "Missiles",
          "missile_racks": "Racks de missiles",
          "utility_items": "Objets utilitaires",
          "utility": "Objets utilitaires",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Station de remplissage de récupération",
          "cargogrid": "Grille de cargaison",
          "controller": "Lames de vol",
          "seat": "Sièges",
          "thrusters": "Propulseurs",
          "bombcompartments": "Soutes à bombes"
        },
        "name": "Nom",
        "category": "Catégorie",
        "source": "Source",
        "powerConsumption": "Consommation d'énergie",
        "powerMinimumFraction": "Consommation au repos",
        "signatureEm": "Signature EM",
        "signatureIr": "Signature IR",
        "mining": {
          "fracturePower": "Puissance de fracturation",
          "extractionPower": "Puissance d'extraction",
          "range": "Portée",
          "chargeTime": "Charge / décharge",
          "moduleSlots": "Emplacements de module",
          "activation": "Type",
          "active": "Actif",
          "passive": "Passif",
          "charges": "Utilisations",
          "duration": "Durée",
          "modifiers": {
            "instability": "Instabilité",
            "resistance": "Résistance",
            "optimalChargeWindow": "Fenêtre de charge optimale",
            "optimalChargeRate": "Vitesse de charge optimale",
            "catastrophicChargeRate": "Vitesse de charge critique",
            "shatterDamage": "Dégâts d'éclatement",
            "inertMaterials": "Matériaux inertes"
          }
        },
        "salvage": {
          "salvageSpeed": "Vitesse de récupération",
          "radius": "Rayon du faisceau",
          "extractionEfficiency": "Efficacité d'extraction"
        },
        "utility": {
          "capacity": "Capacité"
        },
        "selfDestruct": {
          "damage": "Dégâts",
          "radius": "Rayon d'explosion",
          "time": "Délai d'amorçage"
        },
        "quantumEnforcement": {
          "jammerRange": "Portée du brouilleur",
          "pulseRadius": "Rayon de l'impulsion",
          "chargeTime": "Temps de charge",
          "cooldownTime": "Temps de recharge"
        },
        "emp": {
          "distortionDamage": "Dégâts de distorsion",
          "radius": "Rayon",
          "chargeTime": "Temps de charge",
          "unleashTime": "Temps de décharge",
          "cooldownTime": "Recharge"
        },
        "lifeSupport": {
          "output": "Production"
        },
        "powerRanges": "Courbe de puissance (faible / moyenne / élevée)",
        "powerSegments": "seg."
      },
      "blank": {
        "propulsion": "Aucune propulsion présente",
        "modular": "Aucun module présent",
        "fleetInvites": "Aucune invitation présente"
      },
      "user": {
        "hangarDefaultSort": "Ordre par défaut",
        "hangarDefaultSortInfo": "Faites glisser un vaisseau par sa poignée pour le réordonner. Disponible tant que l'ordre personnalisé est actif et qu'aucun filtre n'est appliqué.",
        "hangarDefaultSortOptions": {
          "standard": "Standard (vaisseau amiral d'abord, puis nom)",
          "asc": "%{field}, croissant",
          "desc": "%{field}, décroissant"
        },
        "rsiHandle": "Pseudo",
        "rsiHandleVerified": "Vérifié via Citizen iD",
        "rsiHandleVerifiedViaProfile": "Vérifié via le profil RSI",
        "rsiVerification": {
          "title": "Vérifier ton pseudo RSI",
          "token": "Code de vérification",
          "verifiedSince": "Vérifié depuis le %{date}",
          "openProfileSettings": "Modifier ton profil RSI",
          "steps": {
            "copy": "Copie ton code de vérification",
            "paste": "Colle-le dans la courte bio de ton profil RSI. Tu pourras le retirer une fois ton pseudo vérifié.",
            "check": "Vérifie la page citoyen de %{handle}"
          },
          "statuses": {
            "pending": "Vérification de ta page citoyen…",
            "token_missing": "Le code n’est pas encore dans ta bio. RSI peut mettre quelques minutes à afficher une modification.",
            "handle_mismatch": "La page renvoyée par RSI appartient à un autre pseudo.",
            "not_found": "RSI ne connaît aucun citoyen avec ce pseudo.",
            "failed": "Ta page citoyen n’a pas pu être vérifiée. Réessaie dans une minute."
          }
        },
        "location": "Emplacement",
        "currentSystem": "Position actuelle en jeu",
        "tester": "Testeur ?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Adresse email non confirmée",
        "saleNotify": "Je veux recevoir les notifications de vente",
        "publicHangar": "Hangar public activé",
        "publicHangarLoaners": "Afficher le marqueur des prêteurs dans le Hangar Public",
        "publicHangarStats": "Statistiques du Hangar public activées",
        "publicWishlist": "Liste de souhaits publique activée",
        "hideOwner": "Masquer la propriété pour les flottes",
        "tracking": "Autoriser l'analyse d'utilisation anonyme",
        "showOnlineStatus": "Afficher quand je suis en ligne",
        "onlineStatus": "Statut en ligne",
        "online": "En ligne",
        "offline": "Hors ligne",
        "lastActiveAt": "Dernière activité",
        "confirmedAt": "Confirmé le",
        "dateFormat": "Format de date",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "Hangar visible par les amis",
        "friendsHangarStats": "Statistiques du hangar visibles par les amis",
        "friendsWishlist": "Liste de souhaits visible par les amis"
      },
      "adminUser": {
        "superAdmin": "Super administrateur",
        "passwordConfirmation": "Confirmation du mot de passe"
      },
      "vehicle": {
        "customOrder": "Personnalisé",
        "name": "Nom",
        "states": "États",
        "serial": "Série",
        "owner": "commandé par",
        "flagship": "Vaisseau amiral",
        "wanted": "Recherché",
        "loaner": "Prêteur",
        "bundled": "Inclus",
        "bundledWith": "Inclus avec %{parent}",
        "public": "Visibilité publique",
        "fullPublic": "Visibilité Publique incluant le nom",
        "publicShort": "Publique",
        "nameVisible": "Visibilité publique",
        "hidden": "Masqué ?",
        "saleNotify": "Je souhaite recevoir les notifications de vente",
        "hangarGroups": "Groupes",
        "modelPaintSelect": {
          "nullablePrompt": "Sélectionner une peinture",
          "label": "Peinture"
        },
        "bulkGroupEdit": {
          "hint": "Les groupes existants seront remplacés !"
        },
        "hasLoaners": "Prêteurs",
        "boughtViaSelect": {
          "label": "Acheté via"
        }
      },
      "image": {
        "active": "Actif ?",
        "background": "Utiliser comme arrière-plan ?",
        "caption": "Légende",
        "enabled": "Activé?",
        "file": "Fichier image",
        "global": "Global ?",
        "delete": "Supprimer",
        "start": "Démarrer",
        "cancel": "Annuler",
        "processing": "Traitement en cours...",
        "error": "Erreur",
        "name": "Nom",
        "size": "Taille du fichier",
        "dropzone": "Déposer les images ici",
        "cancelUpload": "Annuler le téléchargement",
        "startUpload": "Démarrer le téléchargement",
        "selectImages": "Ajouter des images...",
        "selectFolder": "Ajouter un dossier..."
      },
      "signup": {
        "link": "Vous n’avez pas de compte ?",
        "privacyPolicy": "En créant un compte FleetYards, vous acceptez notre"
      },
      "privacyPolicy": "Politique de Confidentialité",
      "login": "Nom d'utilisateur ou e-mail",
      "username": "Nom d’utilisateur",
      "twoFactorCode": "Code d’authentification à deux facteurs",
      "confirmationCode": "Code de confirmation",
      "email": "E-mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Vous avez déjà un compte?",
      "password": "Mot de passe",
      "passwordConfirmation": "Confirmation du mot de passe",
      "rememberMe": "Se souvenir de moi",
      "emptyList": "Pas de %{name} présent",
      "all": "Tout",
      "supportUs": "Soutenez FleetYards.net",
      "account": {
        "destroyInfo": "Si vous voulez supprimer votre compte et enlever toutes vos informations de Fleetyards.net et ses Services cliquez sur le Bouton ci-dessous. Sachez qu'il s'agit d'une action permanente qui ne peut pas être révoquée.",
        "calendarSubscription": {
          "intro": "Générez un lien privé pour ajouter les événements auxquels vous êtes inscrit à votre application de calendrier personnelle (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Collez le lien dans votre application de calendrier sous « S'abonner à un calendrier » ou « Ajouter par URL ». Toute personne possédant ce lien peut voir les événements auxquels vous êtes inscrit — gardez-le privé."
        },
        "supporterNomination": {
          "label": "Soutien à la flotte",
          "hint": "Ses membres bénéficient des fonctionnalités de flotte tant qu'un don est actif. Vous pouvez choisir avant de donner.",
          "perDonation": "Par don",
          "perDonationHint": "Un don peut soutenir une autre flotte que celle que vous avez choisie.",
          "fleet": "Flotte soutenue"
        },
        "supporterClaimKey": {
          "signedOut": "Connectez-vous pour obtenir votre clé de soutien personnelle.",
          "patreonNote": "associé via votre e-mail, aucune clé nécessaire",
          "label": "Votre clé",
          "hint": "Collez-la dans le message d'un paiement PayPal, Ko-fi ou Buy me a coffee et il sera associé à votre compte. Sur Patreon, l'association se fait par e-mail."
        }
      },
      "filters": {
        "locations": {
          "name": "Rechercher des lieux",
          "system": "Système",
          "parent": "À l’intérieur de",
          "kind": "Type",
          "starmap": "Carte en jeu",
          "shownOnStarmap": "Affiché sur la carte",
          "hiddenOnStarmap": "Masqué sur la carte"
        },
        "components": {
          "name": "Nom",
          "itemType": "Type d'objet",
          "componentClass": "Classe de composant",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?",
          "description": "Description",
          "manufacturer": "Fabricant",
          "category": "Catégorie",
          "subType": "Sous-type"
        },
        "shops": {
          "name": "Nom",
          "type": "Type",
          "model": "Vaisseau",
          "equipment": "Équipement",
          "component": "Composant",
          "commodity": "Marchandise",
          "commodityType": "Type de marchandise"
        },
        "shopCommodities": {
          "commodityType": "Type de marchandise",
          "equipment": "Équipement",
          "component": "Composant",
          "commodity": "Marchandise",
          "model": "Vaisseau",
          "name": "Nom"
        },
        "shopItems": {
          "category": "Catégorie",
          "subCategory": "Sous catégorie",
          "name": "Nom",
          "manufacturer": "Fabricant"
        },
        "stations": {
          "name": "Nom",
          "type": "Type de Station",
          "shops": "Magasins",
          "docks": "Quais"
        },
        "vehicles": {
          "name": "Nom ou nom du vaisseau",
          "lengthLt": "Longueur <=",
          "lengthGt": "Longueur >=",
          "pledgePriceLt": "Prix du Pledge <=",
          "pledgePriceGt": "Prix du Pledge >=",
          "priceLt": "Prix <=",
          "priceGt": "Prix >=",
          "wanted": "Recherché",
          "hidden": "Masqué",
          "public": "Publique",
          "group": "Groupe",
          "loaner": "Prêteurs",
          "bundled": "Snub Crafts inclus",
          "boughtVia": "Acheté via?"
        },
        "models": {
          "name": "Nom",
          "classification": "Classification",
          "focus": "Spécialisation",
          "manufacturer": "Fabricant",
          "onSale": "En Vente",
          "ingameOnly": "Uniquement en jeu",
          "canLandOnPlanets": "Peut se poser sur les planètes",
          "size": "Taille",
          "dockSize": "Taille du quai",
          "price": "Prix",
          "pledgePrice": "Prix du Pledge",
          "productionStatus": "Statut de la production",
          "lengthLt": "Longueur <=",
          "lengthGt": "Longueur >=",
          "beamLt": "Rayon <=",
          "beamGt": "Rayon >=",
          "heightLt": "Hauteur <=",
          "heightGt": "Hauteur >=",
          "pledgePriceLt": "Prix du Pledge <=",
          "pledgePriceGt": "Prix du Pledge >=",
          "priceLt": "Prix <=",
          "priceGt": "Prix >=",
          "willItFit": "Est-ce que cela conviendra ?",
          "withCargo": "Avec cargaison ?",
          "scKeyBlank": "Sans SC Key ?",
          "positionsNeedCuration": "Postes à curer ?",
          "fleetchartImageBlank": "Sans image de diagramme de flotte ?",
          "holoBlank": "Sans Holo ?",
          "frontViewBlank": "Sans image de vue de face ?",
          "topViewColoredBlank": "Sans image de vue de dessus colorée ?",
          "vehicleSize": "Taille de véhicule",
          "dimensionsDrifted": "Dimensions différentes des fichiers de jeu",
          "dimensionsMeasuredAtNull": "Sans dimensions mesurées ?"
        },
        "modelModules": {
          "name": "Nom"
        },
        "manufacturers": {
          "name": "Nom",
          "withModels": "Avec modèles",
          "logoBlank": "Sans logo"
        },
        "supporterContributions": {
          "name": "Rechercher par nom",
          "recurring": "Récurrentes",
          "anonymous": "Anonymes",
          "startedAtGteq": "Démarrées à partir du",
          "startedAtLteq": "Démarrées jusqu'au",
          "user": "Compte lié",
          "linked": "Liaison au compte",
          "linkedOnly": "Liées",
          "linkedVia": "Lié via",
          "unlinkedOnly": "Non liées",
          "sourceStated": "Plateforme indiquée",
          "sourceStatedOnly": "Plateforme indiquée",
          "sourceUnspecifiedOnly": "Plateforme non indiquée",
          "source": "Source"
        },
        "adminNotifications": {
          "search": "Rechercher"
        },
        "images": {
          "model": "Vaisseau"
        },
        "users": {
          "search": "Rechercher",
          "username": "Nom d'utilisateur",
          "email": "E-mail",
          "rsiHandle": "Pseudo RSI"
        },
        "fleets": {
          "name": "Nom",
          "fid": "FID",
          "member": "Membre",
          "members": {
            "search": "Nom d'utilisateur ou surnom",
            "role": "Rôle",
            "state": "Statut",
            "acceptedAtGt": "Rejoint depuis",
            "acceptedAtLt": "Rejoint jusqu'à",
            "invitedAtGt": "Invité depuis",
            "invitedAtLt": "Invité jusqu'à",
            "requestedAtGt": "Demandé depuis",
            "requestedAtLt": "Demandé jusqu'à",
            "declinedAtGt": "Refusé depuis",
            "declinedAtLt": "Refusé jusqu'à"
          },
          "inviteUrls": {
            "expiresAfter": "Expire après",
            "limit": "Nombre maximum d’utilisations"
          },
          "logistics": {
            "search": "Rechercher des objets..."
          }
        },
        "manufacturer": "Fabricant",
        "commodities": {
          "description": "Description",
          "traded": "Échangée quelque part",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?"
        },
        "equipment": {
          "name": "Nom",
          "equipmentType": "Type d'équipement",
          "itemType": "Type d'objet",
          "weaponClass": "Classe d'arme",
          "slot": "Emplacement",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?",
          "subType": "Sous-type"
        },
        "notifications": {
          "search": "Rechercher"
        },
        "blueprints": {
          "org": "Distribué par",
          "scKey": "Clé du jeu",
          "withKnownSource": "A une source connue",
          "withCraftable": "Résultat dans un catalogue",
          "currentVersion": "Dans le build actuel",
          "name": "Rechercher des plans",
          "craftableType": "Produit",
          "source": "Source",
          "withSource": "Source connue",
          "withoutSource": "Aucune source connue",
          "alignment": "Alignement de la source",
          "material": "Utilise le matériau",
          "ownedFilter": "Possédé",
          "owned": "Possédé",
          "notOwned": "Non possédé"
        },
        "missions": {
          "location": "Lieu",
          "ship": "Votre vaisseau",
          "name": "Rechercher des missions",
          "org": "Proposée par",
          "standing": "Réputation",
          "rewarding": "Paie",
          "alignment": "Côté de la loi",
          "kind": "Type",
          "releasedFilter": "Dans la version",
          "released": "Dans la version",
          "unreleased": "Hors version"
        },
        "fleetDirectory": {
          "search": "Nom, FID ou SID",
          "memberCountGteq": "Membres minimum",
          "activity": "Activité",
          "language": "Langue",
          "alignment": "Alignement",
          "commitment": "Engagement",
          "timezone": "Fuseau horaire",
          "recruiting": "Qui recrutent",
          "roleplay": "Jeu de rôle uniquement"
        }
      },
      "station": {
        "docks": "Quais",
        "location": "Localisation",
        "type": "Type",
        "shops": "Magasins",
        "locationPrefix": {
          "default": "Activé",
          "orbit": "autour de l'orbite"
        }
      },
      "tradeRoutes": {
        "intro": "Le meilleur trajet entre deux terminaux pour votre vaisseau, votre budget et l'ancienneté des prix que vous acceptez. Les prix viennent d'UEX et sont actualisés toutes les heures.",
        "yourRun": "Votre trajet",
        "ship": "Vaisseau",
        "noShip": "Choisissez un vaisseau pour classer par bénéfice par trajet",
        "noShipShort": "Aucun vaisseau",
        "scu": "%{count} SCU",
        "budget": "Budget",
        "budgetPlaceholder": "Facultatif",
        "buyIn": "Acheter dans",
        "anySystem": "Tous",
        "commodity": "Marchandise",
        "allCommodities": "Toutes les marchandises",
        "priceAge": "Prix de moins de",
        "priceAges": {
          "day": "24 h",
          "threeDays": "3 jours",
          "any": "Tous"
        },
        "bestRun": "Meilleur trajet",
        "buyAt": "Acheter à",
        "sellAt": "Vendre à",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "saut vers %{system}",
        "pricesFrom": "Prix de %{time}",
        "otherBuyers": {
          "one": "+%{count} autre acheteur",
          "other": "+%{count} autres acheteurs"
        },
        "profitThisRun": "Bénéfice du trajet",
        "profitPerScu": "Bénéfice par SCU",
        "aUecPerScu": "aUEC · %{value} par SCU",
        "load": "Chargement",
        "loadOf": "%{load} sur %{cargo} SCU",
        "thisShip": "Ce vaisseau",
        "unflyable": {
          "origin": "%{ship} ne peut pas se poser à %{terminal}",
          "destination": "%{ship} ne peut pas se poser à %{terminal}",
          "both": "%{ship} ne peut se poser à aucun des deux terminaux"
        },
        "loadLimits": {
          "hold": "Soute pleine",
          "stock": "Limité par le stock",
          "demand": "Limité par la demande",
          "budget": "Limité par le budget"
        },
        "youSpend": "Vous dépensez",
        "pickShipForRun": "Choisissez un vaisseau pour voir le bénéfice d'un trajet.",
        "moreRuns": "Autres trajets",
        "runs": "Trajets",
        "rankBy": "Classer par",
        "profitPerRun": "Bénéfice par trajet",
        "profitPerDistance": "Bénéfice par Gm",
        "shortest": "Le plus court",
        "buySell": "Achat → vente",
        "spend": "Dépense",
        "distance": "Distance",
        "prices": "Prix",
        "profit": "Bénéfice",
        "to": "vers",
        "everyBuyer": "Tous les acheteurs de %{commodity} depuis %{terminal}",
        "empty": "Aucun trajet ne correspond. Essayez des prix plus anciens ou un autre système.",
        "loadExplained": "Le chargement utilise les tailles de caisse acceptées par les deux terminaux et la marchandise, limité par le stock à l'achat, la demande à la vente et votre budget.",
        "poweredByUex": "Prix fournis par UEX"
      },
      "hardpoints": {
        "prefix": "Essayer les configurations avec",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Statistiques basées sur les formules de"
      },
      "scunpacked": {
        "prefix": "Configurations basées sur les produits développés par Gamefiles ",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Sélectionner un vaisseau"
      },
      "table": {
        "selected": "%{count} sélectionné"
      },
      "commodityPrice": {
        "item": "Magasins de marchandise",
        "price": "Prix",
        "type": "Type",
        "shop": "Magasin"
      },
      "syncExtension": {
        "warnings": "Avertissements",
        "status": {
          "started": "Import démarré...",
          "finished": "Import terminé",
          "failed": "Échec de l'import !"
        },
        "processSteps": {
          "fetchHangar": "Récupération des données du hangar RSI",
          "submitData": "Envoi des données au backend de Fleetyards.net"
        },
        "sessionStatus": "Statut de session RSI",
        "checkIdentity": "Vérifier la session RSI",
        "targetGroup": "Groupe pour les vaisseaux trouvés",
        "addBundledVehicles": "Ajouter les snub crafts inclus",
        "addBundledVehiclesHint": "Ajoute le snub craft fourni avec un vaisseau. Ceux déjà dans votre hangar sont conservés.",
        "unmatchedVehiclesAction": "Vaisseaux absents de votre hangar RSI",
        "unmatchedVehiclesActionHint": "Ce qu'il advient des vaisseaux présents ici que la synchronisation ne trouve pas dans votre liste de pledges RSI.",
        "unmatchedHangarGroup": "Groupe dans lequel les classer",
        "unmatchedHangarGroupHint": "Les vaisseaux restent inchangés, ils sont simplement rassemblés dans ce groupe pour que vous puissiez les trier.",
        "unmatchedVehiclesActions": {
          "wishlist": "Les déplacer vers la liste de souhaits",
          "delete": "Les supprimer",
          "keep": "Les laisser inchangés",
          "group": "Les classer dans un groupe"
        },
        "identityStatus": {
          "pending": "Vérification...",
          "notFound": "non trouvé",
          "connected": "connecté"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pages",
          "all": "Tous les articles de promesse",
          "ships": "Vaisseaux",
          "components": "Modules",
          "upgrades": "Améliorations"
        },
        "importedItems": {
          "importedVehicles": "Vaisseaux ajoutés",
          "foundVehicles": "Vaisseaux trouvés",
          "movedVehiclesToWanted": "Vaisseaux déplacés vers la liste de souhaits",
          "deletedVehicles": "Vaisseaux supprimés",
          "groupedVehicles": "Vaisseaux classés dans un groupe",
          "unchangedVehicles": "Vaisseaux laissés inchangés",
          "missingModels": "Vaisseaux non trouvés",
          "importedComponents": "Composants ajoutés",
          "foundComponents": "Composants trouvés",
          "missingComponents": "Composants non trouvés",
          "missingComponentVehicles": "Aucun vaisseau correspondant trouvé pour les composants",
          "importedUpgrades": "Améliorations ajoutées",
          "foundUpgrades": "Améliorations trouvées",
          "missingUpgrades": "Améliorations non trouvées",
          "missingUpgradeVehicles": "Aucun vaisseau correspondant trouvé pour les améliorations"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacité",
        "maxContainerSize": "Conteneur max.",
        "packed": "Empaqueté",
        "totalCargo": "Cargaison totale",
        "didNotFit": "Ne rentre pas",
        "enoughShips": "Quatre vaisseaux remplissent la grille.",
        "addShip": "Ajouter un vaisseau",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Moteur quantique",
        "fuelUsage": "Consommation de carburant",
        "travelTime": "Temps de trajet",
        "poweredBy": "basé sur",
        "rank": "#",
        "size": "Taille",
        "grade": "Grade",
        "sizeValue": "S%{size}",
        "intro": "Le temps que met chaque moteur quantique pour votre saut — et le carburant quantique qu'il consomme.",
        "jumpDistance": "Distance de saut",
        "distanceHint": "1 Mkm équivaut à un million de kilomètres. Traverser Stanton en demande environ 40.",
        "filters": "Filtres",
        "resetFilters": "Réinitialiser",
        "barLegend": "La barre indique le temps par rapport au moteur le plus lent",
        "count": "%{count} moteurs",
        "countFiltered": "%{count} sur %{total} moteurs",
        "noMatch": "Aucun moteur ne correspond à ces filtres.",
        "presets": {
          "moon": "Saut lunaire",
          "short": "Saut court",
          "system": "Traversée de Stanton",
          "far": "Longue distance"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "Tout",
            "description": "Vaisseaux, modules, peintures, vaisseaux de prêt et prix des vaisseaux, tout à la fois."
          },
          "ship_matrix": {
            "name": "Vaisseaux",
            "description": "Tous les vaisseaux avec leurs données et la boutique, depuis la ship matrix de RSI."
          },
          "modules": {
            "name": "Modules",
            "description": "Modules de vaisseaux de la boutique RSI."
          },
          "paints": {
            "name": "Peintures",
            "description": "Peintures de la boutique RSI."
          },
          "loaners": {
            "name": "Vaisseaux de prêt",
            "description": "Les vaisseaux de prêt fournis avec chaque vaisseau, depuis RSI."
          },
          "uex_vehicle_prices": {
            "name": "Prix des vaisseaux",
            "description": "Où acheter et louer les vaisseaux en jeu, depuis UEX."
          },
          "sc_data": {
            "name": "Données du jeu · %{environment}",
            "description": "Tous les catalogues tirés des fichiers du jeu : composants, équipement, marchandises, plans, missions et lieux."
          },
          "sc_data_models": {
            "name": "Vaisseaux des fichiers du jeu",
            "description": "Seulement les vaisseaux, du build par défaut."
          },
          "uex_commodity_prices": {
            "name": "Prix des marchandises",
            "description": "Prix et stocks des terminaux, depuis UEX."
          },
          "uex_component_prices": {
            "name": "Prix des composants",
            "description": "Où les composants sont vendus, depuis UEX."
          },
          "uex_equipment_prices": {
            "name": "Prix de l'équipement",
            "description": "Où l'équipement est vendu, depuis UEX."
          },
          "uex_trade_routes": {
            "name": "Terminaux et routes commerciales",
            "description": "Les terminaux d'UEX et les routes commerciales entre eux."
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "Parent",
          "system": "Système",
          "scKey": "Clé du jeu",
          "scRefs": "Références du jeu",
          "slug": "Slug",
          "gameType": "Type du jeu",
          "build": "Version",
          "children": "Lieux à l'intérieur",
          "missions": "Missions liées",
          "missionTemplates": "Modèles de mission",
          "shownWithParentOnly": "Affiché seulement avec son parent",
          "yes": "Oui",
          "no": "Non",
          "unavailable": "indisponible",
          "appearance": "Apparence",
          "image": "Image",
          "color": "Couleur",
          "appearanceHint": "La couleur remplit le cercle de la planète ou de la lune, ombrée comme une sphère éclairée. Laissée vide, elle est tirée de l’image lors de son envoi.",
          "headerImageHint": "L’image est affichée en en-tête sur la page du lieu.",
          "shops": "Boutiques",
          "shopImageHint": "L’image est affichée en en-tête sur la page de la boutique.",
          "sunHint": "La couleur teinte l’éclat de l’étoile."
        },
        "blueprints": {
          "status": {
            "sourceKnown": "Source connue",
            "outputResolved": "Résultat dans un catalogue"
          },
          "columns": {
            "source": "Source",
            "output": "Résultat",
            "build": "Build",
            "created": "Créé le",
            "slot": "Emplacement",
            "material": "Matériau",
            "type": "Type",
            "quantity": "Quantité",
            "minQuality": "Qualité min.",
            "stat": "Statistique",
            "change": "Variation",
            "base": "Base",
            "ramp": "Progression",
            "kind": "Nature",
            "org": "Org",
            "mission": "Mission",
            "standing": "Réputation",
            "pool": "Pool"
          },
          "makes": "Produit",
          "noOutput": "Dans aucun catalogue",
          "slug": "Slug",
          "scKey": "Clé du jeu",
          "scRef": "Référence du jeu",
          "build": "Build",
          "state": "État",
          "states": {
            "current": "Actuel",
            "retired": "Retiré"
          },
          "createdAt": "Créé le",
          "updatedAt": "Mis à jour le"
        },
        "missions": {
          "unnamed": "Jamais nommée par le jeu",
          "slug": "Slug",
          "scKey": "Clé du jeu",
          "scRef": "Réf du jeu",
          "generator": "Générateur",
          "debugName": "Nom de débogage",
          "build": "Build",
          "difficultyAxes": "Difficulté (habileté / charge / risque / connaissance)",
          "state": "État",
          "states": {
            "retired": "Retirée",
            "released": "Dans la version",
            "unreleased": "Hors version"
          },
          "columns": {
            "released": "Dans la version",
            "generator": "Générateur",
            "build": "Build",
            "rewardKind": "Type",
            "amount": "Montant",
            "rewardDetail": "Détail"
          },
          "filters": {
            "debugName": "Nom de débogage",
            "named": "Nommée",
            "unnamed": "Jamais nommée",
            "namedFilter": "Nommage",
            "currentBuild": "Build actuel uniquement",
            "anyBuild": "N'importe quel build",
            "build": "Build"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Utilisateurs en ligne"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "Autre"
          },
          "linkedVia": {
            "patreon_account": "Compte Patreon",
            "claim_key": "Jeton de soutien",
            "payer_email": "E-mail du payeur",
            "manual": "Défini par un admin"
          }
        },
        "announcements": {
          "columns": {
            "title": "Titre",
            "status": "Statut",
            "deliveries": "Canaux",
            "recipients": "Destinataires",
            "publishedAt": "Envoyée"
          },
          "statuses": {
            "draft": "Brouillon",
            "scheduled": "Planifiée",
            "publishing": "Envoi en cours",
            "published": "Envoyée",
            "failed": "Échec"
          },
          "channels": {
            "in_app": "Dans l'app",
            "discord": "Discord",
            "bluesky": "Bluesky",
            "x": "X.com"
          },
          "deliveryStatuses": {
            "pending": "En attente",
            "succeeded": "Envoyé",
            "skipped": "Ignoré",
            "failed": "Échec"
          },
          "lastTested": "Dernier test %{time}",
          "noChannel": "Choisissez au moins un canal.",
          "notifyUsersInfo": "E-mail seulement si activé.",
          "discordPartsInfo": "Vide : découpé automatiquement.",
          "socialPartsInfo": "Vide : un message rogné. Deux ou plus : un fil.",
          "recipientsCount": "%{count} destinataires",
          "partPosition": "%{position} sur %{total}",
          "deliverySummary": "%{sent}/%{total} envoyés",
          "deliveryFailedCount": "%{count} en échec",
          "deliveryPendingCount": "%{count} en attente",
          "deliverySkippedCount": "%{count} ignorés",
          "attempts": "%{count} tentatives",
          "content": "Contenu",
          "engagement": {
            "likes": "J'aime",
            "reposts": "Republications",
            "replies": "Réponses",
            "quotes": "Citations",
            "noReactions": "Aucune réaction pour l'instant.",
            "fetchedAt": "Mis à jour %{time}",
            "notFetched": "Les chiffres arrivent dans l'heure.",
            "xUnavailable": "X facture la lecture des chiffres. Ouvrez la publication pour les voir.",
            "untracked": "Publié avant le suivi des réactions."
          }
        },
        "resourceAccess": {
          "title": "Accès aux ressources",
          "groups": {
            "ship_data": "Données des vaisseaux",
            "community": "Communauté",
            "system": "Système"
          },
          "privileges": {
            "locations": "Lieux",
            "blueprints": "Plans",
            "models": "Modèles",
            "model_modules": "Modules de modèle",
            "components": "Composants",
            "manufacturers": "Fabricants",
            "vehicles": "Véhicules",
            "images": "Images",
            "fleets": "Flottes",
            "users": "Utilisateurs",
            "supporters": "Soutiens",
            "admins": "Administrateurs",
            "announcements": "Annonces",
            "oauth_applications": "Applications OAuth",
            "maintenance": "Maintenance",
            "imports": "Imports",
            "features": "Fonctionnalités",
            "workers": "Workers",
            "pghero": "PgHero",
            "rsi-api-status": "État de l'API RSI",
            "stats": "Statistiques"
          }
        },
        "versions": {
          "blank": "vide",
          "revertQuestion": "Rétablir ?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Fichiers du jeu",
            "sc_loader": "Fichiers du jeu",
            "uex_price_sync": "Synchronisation des prix UEX",
            "unknown": "Inconnu"
          }
        },
        "models": {
          "unlisted": "Sans modèle"
        }
      },
      "hangarTable": {
        "extraColumns": "Colonnes",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Image large",
          "angledView": "Image 3D",
          "angledViewWide": "Image 3D large",
          "modelManufacturerName": "Fabricant",
          "modelLength": "Longueur",
          "modelBeam": "Largeur",
          "modelHeight": "Hauteur",
          "modelMass": "Masse",
          "modelCargo": "Cargaison",
          "modelMinCrew": "Équipage",
          "modelMaxCrew": "Équipage max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Vitesse max.",
          "modelGroundMaxSpeed": "Vitesse au sol",
          "modelFocus": "Spécialisation",
          "modelProductionStatus": "Statut de production",
          "modelPrice": "Prix",
          "modelPledgePrice": "Prix de Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Colonnes",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Image large",
          "angledView": "Image 3D",
          "angledViewWide": "Image 3D large",
          "modelManufacturerName": "Fabricant",
          "modelLength": "Longueur",
          "modelBeam": "Largeur",
          "modelHeight": "Hauteur",
          "modelMass": "Masse",
          "modelCargo": "Cargaison",
          "modelMinCrew": "Équipage",
          "modelMaxCrew": "Équipage max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Vitesse max.",
          "modelGroundMaxSpeed": "Vitesse au sol",
          "modelProductionStatus": "Statut de production",
          "modelPrice": "Prix",
          "modelPledgePrice": "Prix de Pledge",
          "owner": "Propriétaire",
          "vehiclesCount": "Nombre"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "Escadron seulement"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "au-delà de la capacité de fret",
        "cargoGrid": "Grille de fret",
        "shipInventory": "Inventaire du vaisseau",
        "remaining": "Restant",
        "unmeasured": "%{count} pas encore mesurés",
        "transferTarget": "Destinataire",
        "transferNote": "Note",
        "noStock": "Rien à déplacer",
        "overStock": "Plus que ce que contient cette position",
        "incoming": "Entrants",
        "outgoing": "Sortants",
        "transferStates": {
          "pending": "En attente",
          "completed": "Livré",
          "declined": "Refusé",
          "cancelled": "Annulé",
          "expired": "Expiré"
        },
        "acceptInto": "Accepter dans",
        "reportReason": "Motif",
        "reportReasons": {
          "spam": "Spam",
          "harassment": "Harcèlement",
          "scam": "Arnaque",
          "other": "Autre chose"
        },
        "transferToFleet": "%{fleet} (flotte)",
        "sender": "De",
        "recipient": "À",
        "contents": "Contenu",
        "state": "Statut",
        "sentAt": "Envoyé",
        "transferKinds": {
          "inventory": "Mes inventaires",
          "fleet": "Une flotte",
          "user": "Une personne",
          "mine": "Mes inventaires",
          "fleetInventories": "Cette flotte",
          "contract": "Un contrat sur lequel je travaille"
        },
        "transferTargetKind": "Envoyer à",
        "contractDeliveryTarget": "%{contract} (%{fleet}) : %{destination}",
        "transferFromFleet": "Depuis la flotte",
        "noTransferTargets": "Aucune destination ici",
        "recordedAt": "Enregistré",
        "origin": "De / À",
        "inTransitAmount": "%{amount} en transit",
        "inTransitHint": "Envoyé par un transfert auquel personne n'a répondu. Déjà retiré des totaux.",
        "transferFromFriends": "Mes amis",
        "towardsContract": "Pour un contrat",
        "noContract": "Aucun contrat",
        "forContract": "pour",
        "openInCatalogue": "Ouvrir dans le catalogue"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "Boîte de réception",
        "archive": "Archives",
        "unreadOnly": "Non lues uniquement",
        "status": "Statut",
        "severity": "Gravité",
        "type": "Type",
        "selectPrompt": "Sélectionnez une notification pour la lire",
        "noBody": "Cette notification ne contient aucun détail supplémentaire.",
        "lastSeen": "Vue la dernière fois",
        "expires": "Expire",
        "severities": {
          "info": "Info",
          "warning": "Avertissement",
          "error": "Erreur"
        },
        "types": {
          "paints_import": "Import des peintures",
          "modules_import": "Import des modules",
          "loaner_sync": "Synchronisation des prêts",
          "uex_prices_import": "Synchronisation des prix UEX",
          "uex_commodity_prices_import": "Synchronisation des marchandises UEX",
          "uex_component_prices_import": "Synchronisation des composants UEX",
          "uex_equipment_prices_import": "Synchronisation de l'équipement UEX",
          "uex_trade_routes_sync": "Synchronisation des routes commerciales UEX",
          "new_supporter": "Nouveau soutien",
          "rsi_api_blocked": "API RSI bloquée",
          "rsi_api_unblocked": "API RSI rétablie",
          "weekly_stats": "Rapport hebdomadaire",
          "ship_matrix_import": "Import Ship Matrix",
          "sc_data_import": "Import sc_data",
          "sc_data_unlisted_models": "Vaisseaux non répertoriés",
          "import_run": "Import",
          "oauth_application_review": "Examen d'application OAuth",
          "inventory_transfer_reports": "Transferts d'inventaire signalés"
        }
      },
      "optional": "facultatif",
      "notificationActions": {
        "open": "Ouvrir",
        "openHangar": "Ouvrir le hangar",
        "openWishlist": "Ouvrir la liste de souhaits",
        "openModel": "Voir le vaisseau",
        "openInvite": "Voir l'invitation",
        "reviewRequest": "Examiner la demande",
        "openMembers": "Voir les membres",
        "openFleet": "Ouvrir la flotte",
        "openInventory": "Ouvrir l'inventaire",
        "openEvent": "Ouvrir l'événement",
        "openRoster": "Voir les inscriptions",
        "addToCalendar": "Ajouter au calendrier",
        "openStore": "Boutique Pledge",
        "accept": "Accepter",
        "decline": "Décliner",
        "signUp": "S'inscrire",
        "withdraw": "Se désinscrire",
        "syncAgain": "Synchroniser à nouveau",
        "markAsBought": "Marquer comme acheté",
        "unavailable": "Ceci n'est plus disponible.",
        "openTransfers": "Ouvrir les transferts",
        "openFriends": "Ouvrir les amis",
        "openAllies": "Ouvrir les alliés",
        "openTour": "Ouvrir l'expédition",
        "openContract": "Ouvrir le contrat",
        "openPayouts": "Ouvrir les paiements"
      },
      "notificationTypes": {
        "channels": {
          "app": "Application",
          "mail": "Email",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Compte et hangar",
          "announcements": "Annonces",
          "fleetMembership": "Adhésion à une flotte",
          "fleetEvents": "Événements de flotte",
          "logistics": "Logistique",
          "relationships": "Amis et alliés",
          "tours": "Expéditions",
          "fleetContracts": "Contrats de flotte"
        },
        "announcement": "Annonce",
        "hangar_create": "Vaisseau ajouté au hangar",
        "hangar_destroy": "Vaisseau retiré du hangar",
        "hangar_sync_finished": "Synchronisation du hangar terminée",
        "hangar_sync_failed": "Échec de la synchronisation du hangar",
        "wishlist_create": "Ajouté à la liste de souhaits",
        "wishlist_destroy": "Retiré de la liste de souhaits",
        "model_on_sale": "Modèle en vente",
        "new_model": "Nouveau modèle sorti",
        "fleet_invite": "Invitation de flotte reçue",
        "fleet_member_requested": "Adhésion demandée",
        "fleet_member_accepted": "Adhésion acceptée",
        "fleet_request_accepted": "Demande d'adhésion acceptée",
        "fleet_inventory_item_added": "Objet ajouté à l'inventaire de la flotte",
        "fleet_event_published": "Événement publié",
        "fleet_event_locked": "Inscriptions à l'événement verrouillées",
        "fleet_event_starting_soon": "Événement imminent",
        "fleet_event_started": "Événement démarré",
        "fleet_event_completed": "Événement terminé",
        "fleet_event_cancelled": "Événement annulé",
        "fleet_event_signup_added": "Nouvelle inscription",
        "fleet_event_signup_withdrawn": "Inscription retirée",
        "fleet_event_signup_confirmed": "Inscription confirmée",
        "fleet_event_signup_assigned": "Assigné à un poste",
        "fleet_event_signup_kicked": "Retiré d'un poste",
        "allInGroup": "Tout dans ce groupe",
        "inventory_transfer_received": "Transfert reçu",
        "inventory_transfer_resolved": "Transfert traité",
        "friend_request_received": "Demande d'ami reçue",
        "friend_request_accepted": "Demande d'ami acceptée",
        "fleet_ally_request_received": "Demande d'alliance reçue",
        "fleet_ally_request_accepted": "Demande d'alliance acceptée",
        "tour_join_request_received": "Demande de participation reçue",
        "tour_join_request_accepted": "Demande de participation acceptée",
        "fleet_contract_published": "Contrat publié",
        "fleet_contract_claimed": "Contrat pris en charge",
        "fleet_contract_crew_requested": "Quelqu'un veut rejoindre un contrat",
        "fleet_contract_crew_answered": "Demande d'équipage traitée",
        "fleet_subscription_started": "Fonctionnalités de flotte activées",
        "fleet_subscription_ended": "Fonctionnalités de flotte perdues",
        "fleet_fid_claim_opened": "ID de flotte réclamé",
        "fleet_fid_claim_completed": "ID de flotte transféré",
        "fleet_fid_claim_cancelled": "Réclamation d’ID de flotte terminée",
        "fleet_rsi_verification_lost": "Vérification de flotte perdue",
        "rsi_handle_verification_lost": "Vérification du pseudo RSI perdue",
        "fleet_contract_fulfilled": "Contrat rempli",
        "fleet_contract_settled": "Contrat payé",
        "payout_ledger_settled": "Paiements arrêtés",
        "payout_entry_pending_review": "Dépense en attente de validation",
        "payout_entry_declined": "Dépense refusée"
      },
      "fleets": {
        "missions": {
          "untitled": "Mission sans titre",
          "title": "Titre",
          "description": "Description",
          "team": "Équipe",
          "teams": "Équipes",
          "ship": "Vaisseau",
          "ships": "Vaisseaux",
          "slot": "Poste",
          "slots": "Postes",
          "noTeams": "Aucune équipe ajoutée pour le moment.",
          "noShips": "Aucun vaisseau ajouté pour le moment.",
          "noSlots": "Aucun poste ajouté pour le moment.",
          "archivedTab": "Archivées",
          "activeTab": "Actives",
          "archived": "Archivée",
          "modelSpecific": "Vaisseau précis",
          "modelList": "L'un de ceux-ci",
          "modelListHint": "Le poste accepte n'importe lequel des vaisseaux que vous choisissez.",
          "allowedShips": "Vaisseaux compatibles",
          "anyOf": "L'un de",
          "filterRange": "Plage de filtrage",
          "classification": "Classification",
          "focus": "Spécialisation",
          "minSize": "Taille min.",
          "maxSize": "Taille max.",
          "minCrew": "Équipage min.",
          "minCrewOverride": "Remplacer",
          "minCrewOverrideLabel": "Remplacement de l'équipage min.",
          "minCrewOverrideHint": "Laissez vide pour utiliser l'équipage minimum par défaut du vaisseau.",
          "minCargo": "Cargaison min. (SCU)",
          "createdBy": "Créée par",
          "seats": "Sièges",
          "category": "Catégorie",
          "coverImage": "Image de couverture",
          "scenario": "Scénario",
          "categories": {
            "other": "Autre",
            "ship_combat": "Combat spatial",
            "ground_combat": "Combat au sol",
            "combined_combat": "Combat combiné",
            "mining": "Minage",
            "salvage": "Récupération",
            "cargo_hauling": "Transport de cargaison",
            "exploration": "Exploration"
          }
        },
        "events": {
          "untitled": "Événement sans titre",
          "title": "Titre",
          "description": "Description",
          "briefing": "Briefing",
          "startsAt": "Commence le",
          "endsAt": "Se termine le",
          "timezone": "Fuseau horaire",
          "location": "Lieu de l'événement",
          "meetupLocation": "Lieu de rendez-vous",
          "visibility": "Visibilité",
          "maxAttendees": "Participants max.",
          "autoLockEnabled": "Verrouillage automatique des inscriptions",
          "autoLockMinutesBefore": "Minutes avant le début pour verrouiller",
          "recurring": "Répétition",
          "recurringHint": "Générer automatiquement cet événement selon une périodicité. Les membres s'inscrivent à chaque occurrence.",
          "recurringSummary": "Se répète %{interval}",
          "recurringUntil": "Se répète %{interval} jusqu'au %{date}",
          "recurringForCount": "Se répète %{interval} (%{count} occurrences)",
          "viewSeries": "Voir la série",
          "recurrenceInterval": "Répéter tous les",
          "recurrenceEnd": "Fin",
          "recurrenceEndNever": "Jamais",
          "recurrenceEndOn": "À une date",
          "recurrenceEndAfter": "Après",
          "recurrenceEndOccurrences": "occurrences",
          "recurrenceUnit": {
            "daily": "jours",
            "weekly": "semaines",
            "monthly": "mois"
          },
          "recurrenceWeekdays": "Les jours",
          "recurrenceWeekdaysHint": "Le jour où l'événement commence est toujours inclus.",
          "recurrence": {
            "daily": "tous les jours",
            "weekly": "toutes les semaines",
            "monthly": "tous les mois",
            "everyN": {
              "daily": "tous les %{count} jours",
              "weekly": "toutes les %{count} semaines",
              "monthly": "tous les %{count} mois"
            },
            "onDays": "%{interval} (%{days})"
          },
          "occurrencesSection": "Prochaines occurrences",
          "skipOccurrence": "Ignorer cette occurrence",
          "overrideOccurrence": "Personnaliser l'occurrence du %{date}",
          "overrideOccurrenceShort": "Modifier celle-ci",
          "overrideOccurrenceHint": "Personnalisez des champs pour cette seule occurrence. Laissez vide pour hériter de l'événement récurrent.",
          "endSeriesHere": "Arrêter ici et pour la suite",
          "splitSeriesHere": "Modifier celle-ci et les suivantes",
          "splitSeriesConfirm": "Poursuivre la série à partir de cette date sous forme de nouvel événement ? Les inscriptions pour cette date et les suivantes y sont transférées, et le nouvel événement s'ouvre en modification.",
          "excludedBadge": "Ignorée",
          "noUpcomingOccurrences": "Aucune occurrence à venir dans les 12 prochaines semaines.",
          "endSeriesConfirm": "Arrêter la répétition après cette date ? Les occurrences futures ne seront pas générées.",
          "skipOccurrenceSuccess": "Occurrence ignorée.",
          "unskipOccurrence": "Rétablir cette occurrence",
          "unskipOccurrenceSuccess": "Occurrence rétablie.",
          "endSeriesSuccess": "Série arrêtée à partir de cette date.",
          "cancelledReason": "Motif d'annulation",
          "createdBy": "Créé par",
          "signups": "Inscriptions",
          "signupsCount": "%{count} inscriptions",
          "youAreHere": "Vous êtes ici",
          "attendance": "Participation",
          "signupsLockedHint": "Les inscriptions sont verrouillées pour cet événement.",
          "alreadySignedUpHint": "Vous êtes déjà inscrit à un autre poste. Désinscrivez-vous d'abord pour en changer.",
          "slotTakenHint": "Ce poste est déjà pris.",
          "currentSlot": "Poste actuel",
          "currentSlotHint": "Il s'agit du poste où se trouve actuellement l'inscription.",
          "takenBy": "Pris par %{username}",
          "slotPickerHint": "Choisissez un poste pour cette inscription. Les postes déjà pris ou indisponibles sont désactivés.",
          "signupCtaHint": "Inscrivez-vous à l'événement — vous pouvez choisir un poste précis maintenant ou laisser un administrateur vous en attribuer un plus tard.",
          "noSlotYet": "Pas encore de poste",
          "signupApproval": "Validation des inscriptions",
          "signupStatuses": {
            "confirmed": "Confirmée",
            "tentative": "Provisoire",
            "interested": "Intéressé",
            "pending": "En attente de validation",
            "withdrawn": "Retirée"
          },
          "signupApprovals": {
            "direct": "Directe",
            "confirmation_required": "Confirmation requise"
          },
          "unassignedSignupsHint": "Ces membres se sont inscrits à l'événement mais n'ont pas encore de poste. Attribuez-leur un poste ci-dessous ou retirez l'inscription.",
          "taken": "Pris",
          "grantedRoles": "Rôles attribués",
          "noEventAdminsYet": "Aucun administrateur ni modérateur supplémentaire pour le moment.",
          "creator": "Créateur de l'événement",
          "eventTeamHint": "Accordez à d'autres membres des droits d'administrateur ou de modérateur pour cet événement. Les administrateurs peuvent le modifier, les modérateurs peuvent gérer les inscriptions.",
          "eventRole": "Rôle",
          "eventRoles": {
            "admin": "Administrateur",
            "moderator": "Modérateur"
          },
          "memberPicker": "Membre",
          "spawnedEvents": "Événements créés",
          "fromMission": "Depuis la mission",
          "pickTemplate": "Choisir un modèle",
          "changeTemplate": "Changer de modèle",
          "clearTemplate": "Retirer le modèle",
          "myVehicle": "Mon véhicule",
          "selectVehicle": "Sélectionner un véhicule (facultatif)",
          "vehicleMismatchHint": "Le véhicule sélectionné ne correspond pas aux exigences de ce poste.",
          "noFittingInHangar": "Rien dans votre hangar ne convient à ce poste. Vous pouvez tout de même vous inscrire en laissant le véhicule vide.",
          "vehicleFitsHint": "Apporte un véhicule qui convient à ce vaisseau.",
          "notes": "Notes",
          "upcomingTab": "À venir",
          "pastTab": "Passés",
          "archivedTab": "Archivés",
          "listTab": "Liste",
          "calendarTab": "Calendrier",
          "subscribeHint": "Copie l'URL du flux de calendrier dans votre presse-papiers afin que vous puissiez la coller dans votre application de calendrier.",
          "visibilities": {
            "members": "Membres",
            "officers": "Officiers",
            "fleet": "Public",
            "squadron": "Escadron seulement"
          },
          "statuses": {
            "draft": "Brouillon",
            "open": "Inscriptions ouvertes",
            "locked": "Inscriptions verrouillées",
            "active": "En direct",
            "completed": "Terminé",
            "cancelled": "Annulé",
            "past": "Passé"
          },
          "tabs": {
            "basic": "Informations de base",
            "description": "Description et couverture",
            "teams": "Équipes et vaisseaux",
            "overview": "Aperçu",
            "settings": "Paramètres"
          },
          "calendar": {
            "month": "Mois",
            "week": "Semaine",
            "weekTitle": "Semaine du %{date}"
          },
          "repeats": "Répétition"
        },
        "contracts": {
          "tabs": {
            "details": "Détails",
            "delivery": "Livraison",
            "crew": "Équipage et prime",
            "goods": "Marchandises"
          },
          "title": "Titre",
          "description": "Description",
          "reward": "Récompense",
          "deadline": "Échéance",
          "crewLimit": "Limite d'équipage",
          "visibility": "Visibilité",
          "visibilities": {
            "members_only": "Tous les membres",
            "squadron_only": "Escadron seulement"
          },
          "reimburseExpenses": "Rembourser les frais",
          "from": "Récupérer à",
          "to": "Livrer à",
          "toHint": "Les livraisons dans l'un de vos propres inventaires vous sont adressées, et vous les acceptez vous-même.",
          "toAuthorHint": "Les livraisons sont adressées à %{username}, qui les accepte.",
          "myHangarInventory": "%{name} (mon hangar)",
          "authorHangarInventory": "%{name} (hangar de %{username})",
          "destinationRemoved": "N'est plus disponible",
          "lead": "Responsable",
          "pendingCrew": "En attente",
          "minQuality": "qualité min. %{value}",
          "pickedUp": "%{quantity} récupéré",
          "itemName": "Article",
          "itemCategory": "Catégorie",
          "itemUnit": "Unité",
          "itemQuantity": "Quantité",
          "kind": {
            "label": "Type",
            "transport": "Transport",
            "procurement": "Approvisionnement",
            "crafting": "Fabrication"
          },
          "state": {
            "draft": "Brouillon",
            "open": "Ouvert",
            "in_progress": "En cours",
            "fulfilled": "Rempli",
            "cancelled": "Annulé",
            "expired": "Expiré",
            "settled": "Réglé"
          },
          "itemTypes": {
            "Commodity": "Marchandise",
            "Component": "Composant",
            "Equipment": "Équipement"
          },
          "qualityMatch": "Correspondance",
          "exactQuality": "exactement %{value}",
          "qualityMatches": {
            "at_least": "Au moins",
            "exact": "Exactement"
          },
          "itemQuality": "Qualité",
          "titleHint": "Facultatif — sans titre, le contrat prend le nom des marchandises demandées",
          "postedBy": "Publié par",
          "claimedBy": "pris par",
          "delivered": "Livré",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "Ouverts",
            "closed": "Clos",
            "mine": "Les miens",
            "completed": "Terminés"
          }
        }
      },
      "commodity": {
        "name": "Nom",
        "buyPrice": "Achat",
        "sellPrice": "Vente",
        "retired": "Absent de la version actuelle",
        "containerSizes": "Tailles de conteneur (SCU)",
        "pieceVolume": "Volume par pièce (SCU)",
        "consumable": "Consommable",
        "refinesInto": "Se raffine en",
        "refinedFrom": "Raffiné à partir de",
        "availability": {
          "retired": "Les prix sont suivis pour la version sur laquelle se trouve le catalogue, et cette marchandise n'y figure pas.",
          "craftedOnly": "Aucun terminal ne l'échange — c'est un matériau de fabrication.",
          "none": "Aucun terminal connu n'achète ni ne vend ceci."
        },
        "chart": {
          "buyHighest": "Prix d'achat le plus élevé",
          "buyAverage": "Prix d'achat moyen",
          "buyLowest": "Prix d'achat le plus bas",
          "sellHighest": "Prix de vente le plus élevé",
          "sellAverage": "Prix de vente moyen",
          "sellLowest": "Prix de vente le plus bas"
        },
        "types": {
          "agricultural_supply": "Fournitures agricoles",
          "alloy": "Alliages",
          "consumer_goods": "Biens de consommation",
          "drink": "Boissons",
          "food": "Nourriture",
          "gas": "Gaz",
          "hpmc": "HPMC",
          "manmade": "Synthétique",
          "medical_supply": "Fournitures médicales",
          "metal": "Métaux",
          "military_supply": "Fournitures militaires",
          "mineral": "Minéraux",
          "natural": "Naturel",
          "nonmetals": "Non-métaux",
          "plasma_fuel": "Carburant plasma",
          "processed_goods": "Produits transformés",
          "quantum_fuel": "Carburant quantique",
          "rmc": "RMC",
          "scrap": "Ferraille",
          "vice": "Vice",
          "waste": "Déchets"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Type d'équipement",
        "itemType": "Type d'objet",
        "subType": "Sous-type",
        "weaponClass": "Classe d'arme",
        "slot": "Emplacement",
        "size": "Taille",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "Nom",
        "manufacturer": "Fabricant",
        "retired": "Absent de la version actuelle",
        "noMetrics": "Aucune donnée n'est enregistrée pour cet objet.",
        "availability": {
          "retired": "Les prix sont suivis pour la version sur laquelle est le catalogue, et cet objet n'en fait pas partie.",
          "craftedOnly": "Aucun terminal ne le vend : il se fabrique à partir de la recette ci-dessous.",
          "none": "Aucun terminal ne l'achète ni ne le vend."
        },
        "stats": {
          "damageReduction": "Réduction des dégâts",
          "temperatureRating": "Plage de température",
          "radiationProtection": "Protection contre les radiations",
          "radiationScrubRate": "Taux d'élimination des radiations",
          "gForceTolerance": "Tolérance aux G",
          "carryingCapacity": "Capacité de transport",
          "magazineSize": "Capacité du chargeur",
          "rateOfFire": "Cadence de tir",
          "range": "Portée effective",
          "weaponClass": "Classe d'arme",
          "coreCompatibility": "Compatibilité du noyau",
          "backpackCompatibility": "Compatibilité sac à dos",
          "volume": "Volume"
        },
        "sorts": {
          "damageReduction": "Réduction des dégâts",
          "radiationProtection": "Protection contre les radiations",
          "gForceTolerance": "Tolérance aux G",
          "rateOfFire": "Cadence de tir",
          "range": "Portée",
          "storage": "Capacité",
          "volume": "Volume"
        }
      },
      "notifications": {
        "inbox": "Boîte de réception",
        "archive": "Archives",
        "unreadOnly": "Non lues uniquement",
        "status": "Statut",
        "type": "Type",
        "selectPrompt": "Sélectionnez une notification pour la lire",
        "noBody": "Cette notification ne contient aucun détail supplémentaire.",
        "archivesOn": "Passe aux archives",
        "deletesOn": "Supprimée"
      },
      "unlistedModel": {
        "linkHint": "Quel vaisseau du catalogue est %{identifier} ? La suggestion vient de l'export et peut être fausse."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Source",
        "sources": {
          "vehicle": "Vaisseau",
          "handMade": "Créé manuellement"
        }
      },
      "inventoryItems": {
        "name": "Nom",
        "category": "Catégorie",
        "entryType": "Mouvement",
        "quantity": "Quantité",
        "quality": "Qualité",
        "notes": "Notes",
        "itemType": "Catalogue",
        "categories": {
          "commodity": "Marchandise",
          "component": "Composant",
          "weapon": "Arme",
          "equipment": "Équipement",
          "ammunition": "Munitions",
          "consumable": "Consommable",
          "other": "Autre"
        },
        "entryTypes": {
          "deposit": "Dépôt",
          "withdrawal": "Retrait"
        },
        "units": {
          "scu": "SCU",
          "units": "unités"
        }
      },
      "shipHistory": {
        "sales": "Historique des soldes",
        "salesCount": "Soldes enregistrés",
        "lastSale": "Dernier solde",
        "averageGap": "Écart moyen",
        "days": "%{count} jours",
        "ongoing": "En cours",
        "priceHistory": "Historique du prix pledge",
        "firstPriced": "Premier prix",
        "priceRemoved": "Prix retiré",
        "wishlist": "Ajouts en liste de souhaits par mois",
        "patchChanges": "Modifications de patch",
        "notRecordedYet": "Enregistré seulement depuis le début du suivi, un vaisseau peut donc n'avoir rien."
      },
      "buildCompare": {
        "from": "Depuis le build",
        "to": "Vers le build",
        "appeared": "Apparus",
        "vanished": "Disparus",
        "changed": "Modifiés",
        "notRecorded": "Non enregistré pour l'un de ces builds.",
        "needsTwoBuilds": "Un seul build est enregistré, il n'y a donc rien à comparer.",
        "pickTwoBuilds": "Choisis deux builds différents.",
        "failed": "Impossible de comparer ces deux builds.",
        "andMore": "et %{count} de plus",
        "catalogues": {
          "components": "Composants",
          "equipment": "Équipement",
          "commodities": "Marchandises",
          "models": "Vaisseaux"
        }
      },
      "dockAccess": {
        "ramp": "Rampe",
        "lift": "Ascenseur",
        "tractor_beam": "Rayon tracteur"
      },
      "dockTypes": {
        "vehiclepad": "Plateforme véhicule",
        "garage": "Garage",
        "landingpad": "Aire d'atterrissage",
        "dockingport": "Port d'amarrage",
        "hangar": "Hangar",
        "cargogrid": "Grille de fret"
      },
      "shipSizes": {
        "extra_extra_small": "Snubcraft (XXS)",
        "extra_small": "Très petit (XS)",
        "small": "Petit (S)",
        "medium": "Moyen (M)",
        "large": "Grand (L)",
        "extra_large": "Très grand (XL)",
        "capital": "Capital (C)"
      },
      "payouts": {
        "currency": "Devise",
        "archived": "Archivée",
        "activeTours": "En cours",
        "amount": "Montant",
        "description": "Description",
        "entryType": "Type",
        "expense": "Dépensé",
        "income": "Gagné",
        "participant": "Qui",
        "notes": "Notes",
        "occurredAt": "Quand",
        "paid": "Dépensé",
        "held": "Détient",
        "share": "Part",
        "net": "Solde",
        "profit": "Bénéfice",
        "totalIncome": "Gagné",
        "totalExpenses": "Dépensé",
        "guest": "Invité",
        "username": "Nom d'utilisateur",
        "name": "Nom",
        "sends": "envoie",
        "receives": "reçoit",
        "settled": "Clôturé",
        "open": "Ouvert",
        "owes": "doit",
        "isOwed": "doit recevoir",
        "even": "à jour",
        "title": "Titre",
        "fleet": "Flotte",
        "startsAt": "Commence le",
        "inviteLink": "Lien d'invitation",
        "participants": "Personnes",
        "weight": "Pondération",
        "shares": "parts",
        "customWeight": "Pondération libre",
        "preview": "Aperçu · évolue jusqu'au règlement",
        "joinRequestPending": "Demande en attente",
        "payer": "Payeur",
        "declineReason": "Motif",
        "review": {
          "pending": "En attente de validation",
          "approved": "Approuvée",
          "declined": "Refusée"
        }
      },
      "relationships": {
        "party": "Nom",
        "since": "Depuis",
        "tabs": {
          "accepted": "Actifs",
          "incoming": "Entrantes",
          "outgoing": "Envoyées",
          "ignored": "Ignorées"
        },
        "user": {
          "handle": "Nom d'utilisateur"
        },
        "fleet": {
          "handle": "Identifiant de la flotte"
        },
        "requested": "Demande envoyée",
        "friend": "Amis"
      },
      "blueprint": {
        "name": "Nom",
        "craftTime": "Temps de fabrication",
        "slots": "Emplacements",
        "materials": "Matériaux",
        "quality": "Qualité",
        "missionSlots": {
          "location": "lieu",
          "objects": "objets",
          "target": "cible",
          "ship": "vaisseau",
          "cargo": "cargaison",
          "rank": "rang",
          "danger": "danger",
          "contract": "contrat",
          "other": "variable"
        },
        "missionSlotsHint": "Les termes entre ‹chevrons› sont renseignés par le jeu lorsque le contrat est proposé.",
        "atNeutral": "%{value} à Q500",
        "whatYouGet": "Ce que vous obtenez",
        "fromSlots": "%{count} emplacements",
        "factorOnly": "facteur seul — aucune valeur au catalogue",
        "heldIn": "dans",
        "heldOn": "sur",
        "fromHangar": "Hangar",
        "makes": "Produit",
        "makesA": "Plan de fabrication · produit",
        "makesUnknown": "Plan de fabrication · produit un objet absent de tous les catalogues",
        "retired": "Retiré",
        "minQuality": "Min. %{quality}",
        "belowGate": "Sous le seuil de cet emplacement — un matériau inférieur à %{quality} n'y entre pas.",
        "unvalued": "concerné — le jeu n'indique aucune valeur",
        "noStats": "Cet emplacement ne modifie aucune statistique — le matériau doit simplement être présent.",
        "noMaterials": "Les fichiers du jeu n'indiquent aucun matériau pour ce plan.",
        "setEverySlot": "Régler tous les emplacements",
        "qualityAll": "tous les emplacements à %{quality}",
        "qualityRange": "%{from}–%{to} selon les emplacements",
        "anyOf": "%{count} au choix parmi ces %{total}",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "Où l'obtenir",
        "fleetOwners": "Qui peut le fabriquer",
        "ownedByCount": "%{count} le possèdent",
        "sourceSummary": "%{count} sources · %{orgs} organisations",
        "unattributed": "Non attribué",
        "minPoints": "À partir de %{points} points",
        "noKnownSource": "Aucune source connue",
        "noSourceLead": "Aucune mission ni aucun scénario ne distribue ce plan.",
        "noSourceBody": "Les fichiers du jeu ne le placent dans aucun lot de récompenses : il n'y a donc rien à indiquer.",
        "empty": "Aucun plan ne correspond.",
        "craftableTypes": {
          "Component": "Composant",
          "Equipment": "Équipement",
          "Commodity": "Marchandise"
        },
        "alignments": {
          "lawful": "Légal",
          "neutral": "Neutre",
          "outlaw": "Hors-la-loi"
        },
        "kinds": {
          "contract": "Contrat",
          "scenario": "Scénario"
        },
        "duration": {
          "hours": "%{count} h",
          "minutes": "%{count} min",
          "seconds": "%{count} s"
        }
      },
      "gameMission": {
        "locationNamedInText": "cité dans le briefing",
        "locations": "Où elle se déroule",
        "locationKinds": {
          "surface": "Sur une planète ou une lune",
          "space": "Dans l'espace",
          "mixed": "Planète, lune ou espace",
          "unknown": "Lieu inconnu"
        },
        "location": "Lieu",
        "cannotLand": {
          "surface": "%{ship} ne peut pas se poser : ce contrat se déroule sur une planète ou une lune",
          "mixed": "Peut mener %{ship} sur une planète ou une lune, où il ne peut pas se poser"
        },
        "calculatedInGame": "Calculé en jeu",
        "blueprints": "Plans",
        "name": "Nom",
        "org": "Proposée par",
        "offeredBy": "Proposée par",
        "offeredByUnknown": "Aucun commanditaire indiqué",
        "standing": "Réputation",
        "kind": "Type",
        "kinds": {
          "career": "Carrière",
          "contract": "Ponctuelle"
        },
        "difficulty": "Difficulté",
        "difficultyAxes": {
          "mechanicalSkill": "Habileté mécanique",
          "mentalLoad": "Charge mentale",
          "riskOfLoss": "Risque de perte",
          "gameKnowledge": "Connaissance du jeu"
        },
        "alignments": {
          "lawful": "Légal",
          "neutral": "Neutre",
          "outlaw": "Hors-la-loi"
        },
        "rewards": "Récompenses",
        "rewardKinds": {
          "blueprint": "Plans",
          "reputation": "Réputation",
          "item": "Objets",
          "badge": "Insigne",
          "currency": "Paiement"
        },
        "oneOfASet": "un parmi un lot",
        "briefing": "Briefing",
        "templatedNote": "Le jeu remplit les parties marquées au moment où il attribue la mission.",
        "payoutNote": "Le jeu calcule le paiement à la génération de la mission ; les fichiers n'en indiquent donc un que pour une poignée de contrats.",
        "noRewards": "Les fichiers n'indiquent aucune récompense pour celle-ci.",
        "unreleased": "Hors version",
        "retired": "Retirée"
      },
      "fleetDirectory": {
        "name": "Flottes",
        "memberCount": "Membres",
        "createdAt": "Plus récentes",
        "language": "Langue",
        "recruiting": "Recrute",
        "notRecruiting": "Ne recrute pas",
        "roleplay": "Jeu de rôle",
        "rsiSid": "SID %{sid}"
      }
    }
  }
}
